<template>
	<main
		ref="mainScrollContainer"
		@scroll="observeSections"
		class="es-main-container position-relative overflow-auto"
	>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="showShimmer"
		>
			<Spinner />
		</div>
		<div class="dot-indicator">
			<div
				v-for="n in totalSections"
				:key="n"
				class="dot"
				:class="{ active: activeSection === n }"
			></div>
		</div>
		<section class="h-100">
			<section
				class="es-first-section d-flex align-items-center justify-content-between"
			>
				<div
					class="w-25 d-flex align-items-center gap-4"
					:class="overallResult.candidateType == 'I' ? 'w-33' : 'w-25'"
				>
					<div
						v-if="!$route.query.fromRec"
						@click="$router.go(-1)"
						class="pointer"
					>
						<img src="../../assets/common-icons/arrow.svg" alt="" />
					</div>
					<div class="w-90">
						<h4 class="fs-14 fw-500 font-lato color-969696">Topic Name :</h4>
						<h6
							class="mb-0 fw-600 font-mont fs-14 color-72738e text-truncate pr-2"
						>
							<span
								v-b-popover.hover.top="
									`${getFormattedTopicName(overallResult.topicName)}`
								"
								>{{ getFormattedTopicName(overallResult.topicName) }}</span
							>
						</h6>
					</div>
				</div>
				<div
					class="w-25"
					:class="overallResult.candidateType == 'I' ? 'w-33' : 'w-25'"
				>
					<h4 class="fs-14 fw-500 font-lato color-969696">Test Name :</h4>
					<h6
						class="mb-0 fw-600 font-mont fs-14 color-72738e text-truncate pr-2"
					>
						<span
							class="text-truncate"
							v-b-popover.hover.top="`${overallResult.testName}`"
							>{{ overallResult.testName }}</span
						>
					</h6>
				</div>
				<div class="w-25" v-if="overallResult.candidateType != 'I'">
					<h4 class="fs-14 fw-500 font-lato color-969696">Group Name :</h4>
					<h6
						class="mb-0 fw-600 font-mont fs-14 color-72738e text-truncate pr-2"
					>
						{{ overallResult.groupName }}
					</h6>
				</div>
				<div class="w-25" v-if="overallResult.priorityAttemptID != null">
					<div class="es-priority-container">
						<div>
							<img
								class="mr-2"
								src="../../assets/icons/proctoring/priorityicon.svg"
								alt=""
							/>
							<span class="fs-12 fw-400 font-poppins color-72738e"
								>Priority Attempt is :</span
							>
							<span class="fs-12 fw-600 font-poppins color-72738e">
								Attempt {{ overallResult.priorityAttemptID }}</span
							>
						</div>
						<p class="fs-12 fw-400 font-poppins color-ababab mb-0">
							{{ overallResult.priorityAttemptStatus }}
						</p>
					</div>
				</div>
			</section>
			<section class="es-attempt-tab-container">
				<b-card no-body>
					<b-tabs pills card>
						<b-tab
							v-for="(candidate, index) in overallResult.attempts"
							:key="index"
							:title="`Attempt ${index + 1}`"
							:active="tabIndex === index"
							@click="getProctorDetailsData(candidate, $event)"
						>
							<template #title>
								<span>
									Attempt {{ index + 1 }}
									<img
										v-if="candidate == overallResult.priorityAttemptID"
										src="../../assets/icons/proctoring/priorityicon.svg"
										alt=""
										class="ml-1"
										style="margin-top: -3px;"
									/>
								</span>
							</template>
							<section
								v-if="selectedAttempt.attemptNo == index + 1"
								id="section-1"
								class="d-flex align-items-center"
								style="height: 460px;"
							>
								<section class="es-firstsec-left-container w-25 h-100">
									<div class="d-flex flex-column align-items-center">
										<img
											v-if="selectedAttempt.image"
											:src="selectedAttempt.image"
											alt=""
											class="es-profile-dp mb-2 mt-3"
										/>
										<b-avatar
											v-else
											class="es-profile-dp mb-2 mt-3"
											variant="dark"
											:text="selectedAttempt.name.substring(0, 2).toUpperCase()"
										>
										</b-avatar>
										<h5 class="fw-600 fs-16 color-white font-mont mt-2">
											{{ selectedAttempt.name }}
										</h5>
										<h6 class="fw-400 fs-16 color-f5f5f5 font-lato mt-2">
											{{ selectedAttempt.emailID }}
										</h6>
										<div
											class="es-profile-btn color-white fs-14 fw-400 font-poppins my-2"
										>
											Attempt {{ selectedAttempt.attemptNo }}
										</div>
									</div>
									<div class="white-dotted-hr my-2"></div>
									<div
										class="fw-400 font-lato fs-16 color-f5f5f5 d-flex px-3 mt-2"
									>
										<div class="w-10">
											<img
												src="../../assets/newimgs/device.svg"
												class="mr-2"
												alt=""
											/>
										</div>
										{{
											selectedAttempt.stats &&
											selectedAttempt.stats.system &&
											selectedAttempt.stats.system.version
												? selectedAttempt.stats.system.version
												: "--"
										}}
									</div>
									<div
										class="fw-400 font-lato fs-16 color-f5f5f5 d-flex px-3 mt-3"
									>
										<div class="w-10">
											<img
												src="../../assets/newimgs/location.svg"
												class="mr-2"
												alt=""
											/>
										</div>
										{{
											checkForGeolocation()
												? selectedAttempt.stats.geolocation.address
														.formatted_address
												: "--"
										}}
									</div>
								</section>
								<section class="es-firstsec-right-container w-75 h-100 p-3">
									<section class="d-flex justify-content-between">
										<div class="w-30">
											<h6 class="fw-500 fs-14 font-mont color-989898">
												Date & Time
											</h6>
											<h4 class="fw-700 fs-16 font-mont color-matte-blue">
												{{ formatDateTime(selectedAttempt) }}
											</h4>
										</div>
										<div class="w-30 d-flex flex-column align-items-left">
											<h6 class="fw-500 fs-14 font-mont color-989898">
												Time Taken
											</h6>
											<h4 class="fw-700 fs-16 font-mont color-orange">
												{{
													selectedAttempt.stats && selectedAttempt.stats.timing
														? (
																"0" +
																selectedAttempt.stats.timing.duration.slice(
																	0,
																	7
																)
														  ).slice(-8) + " (HH:MM:SS)"
														: "--"
												}}
											</h4>
										</div>
										<div
											class="w-30 d-flex flex-column align-items-center"
											v-if="selectedAttempt.evaluation"
										>
											<h6 class="fw-500 fs-14 font-mont color-989898">
												Marks
											</h6>
											<h4 class="fw-700 fs-16 font-mont color-696969">
												{{
													selectedAttempt.marks !== undefined
														? `${
																selectedAttempt.marks
														  }/${selectedAttempt.totalTestMarks
																.toString()
																.substring(0, 4)}`
														: "--"
												}}
											</h4>
										</div>
									</section>
									<div class="grey-dotted-hr my-3"></div>
									<section
										class="d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											<h6 class="fw-500 fs-14 font-mont color-989898">
												Cheating probability:
											</h6>
											<h4
												class="fw-800 fs-18 font-mont ml-2"
												:class="
													allProctorData &&
													allProctorData.length > 0 &&
													allProctorData[0].cheatingProbablityPercentage > 0
														? 'color-red'
														: 'color-989898'
												"
											>
												{{
													allProctorData &&
													allProctorData.length > 0 &&
													allProctorData[0].cheatingProbablityPercentage
														? allProctorData[0].cheatingProbablityPercentage +
														  "%"
														: selectedAttempt.enableProctoring
														? "--"
														: "N/A"
												}}
											</h4>
											<div
												v-if="
													allProctorData &&
														allProctorData.length > 0 &&
														allProctorData[0].cheatingProbablityPercentage > 55
												"
												class="es-cheating-tag font-inter color-red fw-500 fs-14 ml-2 mt-n2"
											>
												High Cheating Probability
											</div>
										</div>
										<div
											v-if="selectedAttempt.evaluation"
											@click="showViewMarksModal = true"
											class="pointer es-viewmark-btn text-center color-white fw-600 fs-13 font-mont"
										>
											<img src="../../assets/newimgs/viewmarks.svg" alt="" />
											View Marks
										</div>
										<div
											v-else
											class="es-notevlted d-flex align-items-center justify-content-center color-red fw-600 fs-13 font-mont"
										>
											{{ getEvaluationText(selectedAttempt) }}
										</div>
									</section>
									<div class="grey-dotted-hr my-3"></div>
									<section
										class="position-relative d-flex align-items-center justify-content-between"
									>
										<div class="w-50">
											<h6 class="fw-500 fs-14 font-mont color-989898">
												Person Face Capture :
											</h6>
											<div
												class="es-idcapture mt-3  d-flex align-items-center justify-content-center"
											>
												<div
													v-if="!selectedAttempt.candidateImage"
													class="fw-400 fs-14 color-white font-poppins d-flex flex-column align-items-center"
												>
													<img
														src="../../assets/newimgs/faceempty.svg"
														alt=""
													/>
													<span> Image not captured</span>
												</div>
												<img
													v-else
													:src="selectedAttempt.candidateImage"
													class="w-100 h-100"
													alt=""
												/>
											</div>
										</div>
										<div class="grey-dotted-hr my-3 es-vertical-line"></div>
										<div class="w-50">
											<h6 class="fw-500 fs-14 font-mont color-989898">
												ID Card Capture: :
											</h6>
											<div
												class="es-idcapture mt-3 d-flex align-items-center justify-content-center"
											>
												<div
													v-if="!selectedAttempt.candidateImageWithID"
													class="fw-400 fs-14 color-white font-poppins d-flex flex-column align-items-center"
												>
													<img
														src="../../assets/newimgs/emptycapture.svg"
														alt=""
													/>
													<span>No ID was captured</span>
												</div>
												<img
													v-else
													:src="selectedAttempt.candidateImageWithID"
													alt=""
													class="w-100 h-100"
												/>
											</div>
										</div>
									</section>
								</section>
							</section>
							<section
								v-if="selectedAttempt.attemptNo == index + 1"
								id="section-2"
								class="position-sticky top-0 z-1 d-flex gap-2 mt-3  py-3"
								style="	height: calc(100vh - 68px);"
							>
								<section
									class="es-secondsec-left-container w-30 h-100 overflow-auto"
								>
									<div
										class="d-flex align-items-center es-greyheader fs-16 fw-600 font-mont color-656565"
									>
										Candidate Face Cam
									</div>
									<div
										class="es-facecam"
										:class="
											selectedAttempt.video && selectedAttempt.video.camera
												? 'my-3'
												: 'my-0'
										"
									>
										<!-- <video
											v-if="
												selectedAttempt.video && selectedAttempt.video.camera
											"
											aria-describedby="video-tag"
											:src="selectedAttempt.video.camera"
											controls
											autoplay
											class="h-100 w-100 overflow-hidden"
										/> -->
										<VideoPlayer
											:videoSrc="selectedAttempt.video.camera"
											:marker1="marker1"
											:marker2="marker2"
											:tooglePlay="tooglePlay"
											:videoDuration="videoDuration"
											:key="'video1'"
											@pause="tooglePlay = false"
											:id="'cameraVideo'"
											v-if="
												selectedAttempt.video && selectedAttempt.video.camera
											"
										/>
										<div v-else class="h-100 w-100 overflow-hidden">
											<img
												src="../../assets/newimgs/emptycamfeed.svg"
												class="h-100 w-100"
												alt=""
											/>
										</div>
									</div>
									<div
										class="d-flex align-items-center es-greyheader fs-16 fw-600 font-mont color-656565"
									>
										Screen Recording
									</div>
									<div
										class="es-facecam"
										:class="
											selectedAttempt.video && selectedAttempt.video.screenShare
												? 'my-3'
												: 'my-0'
										"
									>
										<VideoPlayer
											:videoSrc="selectedAttempt.video.screenShare"
											:marker1="marker1"
											:marker2="marker2"
											:key="'video2'"
											:tooglePlay="tooglePlay"
											:videoDuration="videoDuration"
											@pause="tooglePlay = false"
											:id="'screenVideo'"
											v-if="
												selectedAttempt.video &&
													selectedAttempt.video.screenShare
											"
										/>

										<div v-else class="h-100 w-100 overflow-hidden">
											<img
												src="../../assets/newimgs/emptycamfeed.svg"
												class="h-100 w-100"
												alt=""
											/>
										</div>
									</div>
								</section>
								<section class="w-70">
									<!-- Legend Container (place it above the graph) -->
									<div
										class="graph-wrapper"
										v-if="
											allProctorData && allProctorData.length && graphGeneartion
										"
									>
										<div class="graph-legend">
											<button class="graph-legend-button" id="zoom-in">
												Zoom In
											</button>
											<button class="graph-legend-button" id="zoom-out">
												Zoom Out
											</button>
											<button class="graph-legend-button" id="reset">
												Reset
											</button>
											<div
												class="legend-item pointer"
												v-for="(name, index) in proctoringEvents"
												:key="index"
												@click="getProctorGraph(name)"
											>
												<span
													class="legend-color"
													:style="getClass(name)"
												></span>
												{{ name }}
											</div>
										</div>

										<div
											class="es-secondsec-right-top w-100"
											id="cheatingGraph"
										></div>
									</div>
									<div v-else>
										<div class="es-secondsec-right-top-empty w-100">
											<img src="../../assets/newimgs/no-activity.svg" alt="" />
										</div>
									</div>

									<div class="es-secondsec-right-bottom w-100 mt-3">
										<section class="h-100" v-if="!showLogs">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div>
													<h4 class="fs-14 fw-600 font-inter color-7a7a7a">
														CHEATING PERCENTAGE
													</h4>
													<div class="d-flex align-items-center">
														<h4
															class="fw-800 fs-18 font-mont"
															:class="
																allProctorData &&
																allProctorData.length > 0 &&
																allProctorData[0].cheatingProbablityPercentage >
																	0
																	? 'color-red'
																	: 'color-989898'
															"
														>
															{{
																allProctorData &&
																allProctorData.length > 0 &&
																allProctorData[0].cheatingProbablityPercentage
																	? allProctorData[0]
																			.cheatingProbablityPercentage + "%"
																	: selectedAttempt.enableProctoring
																	? "--"
																	: "N/A"
															}}
														</h4>
														<div
															v-if="
																allProctorData &&
																	allProctorData.length > 0 &&
																	allProctorData[0]
																		.cheatingProbablityPercentage > 55
															"
															class="es-cheating-tag font-inter color-red fw-500 fs-14 ml-2 mt-n2"
														>
															High Cheating Probability
														</div>
													</div>
												</div>
												<div class="d-flex align-items-center gap-3">
													<div
														:class="{
															'selected-es-ss-box':
																proctoringData &&
																proctoringData ===
																	overallResult.videoProctoringData
																		.videoProctoring,
														}"
														class=" es-ss-boxes pointer"
														@click="
															proctoringData =
																overallResult.videoProctoringData
																	.videoProctoring
														"
													>
														<h4 class="fs-14 fw-600 font-inter color-7a7a7a">
															Video Proctoring
														</h4>
														<h3 class="fw-900 fs-18 font-inter color-7a7a7a">
															{{
																overallResult.videoProctoringData
																	.videoProctoringTotalActivityCount ||
																	(selectedAttempt.enableProctoring
																		? "--"
																		: "N/A")
															}}
														</h3>
													</div>
													<div
														:class="{
															'selected-es-ss-box':
																proctoringData &&
																proctoringData ===
																	overallResult.extensionProctoringData
																		.extensionProctoring,
														}"
														class="es-ss-boxes pointer"
														@click="
															proctoringData =
																overallResult.extensionProctoringData
																	.extensionProctoring
														"
													>
														<h4 class="fs-14 fw-600 font-inter color-7a7a7a">
															Browser Proctoring
														</h4>
														<h3 class="fw-900 fs-18 font-inter color-7a7a7a">
															{{
																overallResult.extensionProctoringData
																	.extensionProctoringTotalActivityCount ||
																	(selectedAttempt.enableProctoring
																		? "--"
																		: "N/A")
															}}
														</h3>
													</div>
													<div
														:class="{
															'selected-es-ss-box':
																proctoringData &&
																proctoringData ===
																	overallResult.systemAgentData.systemAgent,
														}"
														class="es-ss-boxes pointer"
														@click="
															proctoringData =
																overallResult.systemAgentData.systemAgent
														"
													>
														<h4 class="fs-14 fw-600 font-inter color-7a7a7a">
															Agent Proctoring
														</h4>
														<h3 class="fw-900 fs-18 font-inter color-7a7a7a">
															{{
																overallResult.systemAgentData
																	.systemAgentTotalActivityCount ||
																	(selectedAttempt.enableProctoring
																		? "--"
																		: "N/A")
															}}
														</h3>
													</div>
												</div>
											</div>
											<div class="grey-dotted-hr my-3"></div>
											<section
												class="overflow-auto"
												style="height: calc(100% - 100px);"
											>
												<b-row
													class="m-0"
													v-if="
														proctoringData &&
															proctoringData.filter((item) => item.count > 0)
																.length
													"
												>
													<b-col
														cols="6"
														v-for="(item, index) in proctoringData.filter(
															(item) => item.count > 0
														)"
														:key="index"
														class="py-2 pl-0 pointer"
														@click="showLogData(item)"
													>
														<div
															class="es-cheatpercentage-container w-100 d-flex justify-content-between align-items-center"
														>
															<h6
																class="color-434F5E font-mont fs-16 fw-500 mb-0"
															>
																{{ item.description }}
															</h6>
															<div class="d-flex align-items-center gap-3">
																<div
																	class="es-cp-tag fw-700 d-flex align-items-center justify-content-center fs-14 font-inter color-72738e"
																>
																	{{ item.count }}
																</div>
																<img
																	src="../../assets/newimgs/greychevoron.svg"
																	alt=""
																/>
															</div>
														</div>
													</b-col>
												</b-row>
												<div v-else class="no-activity-container">
													<img
														src="../../assets/newimgs/no-activity.svg"
														alt=""
													/>
												</div>
											</section>
										</section>

										<section class="h-100" v-if="showLogs">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="d-flex gap-3 align-items-center">
													<img
														@click="showLogs = !showLogs"
														class="pointer"
														src="../../assets/newimgs/backarrowgrey.svg"
														alt=""
													/>
													<h5 class="mb-0 fs-18 fw-600 color-72738e font-mont">
														{{ logData.description }}
													</h5>
												</div>
												<div
													class="es-instance-box text-center fw-700 fs-14 font-inter color-72738e"
												>
													{{ logData.count }} Instance
												</div>
											</div>
											<div class="grey-dotted-hr my-3"></div>
											<section class="h-100">
												<div
													class="es-instance-tableheader font-poppins fw-600 fs-14 color-white d-flex align-items-center"
												>
													<div class="w-25">
														Timestamp
													</div>
													<div class="w-50">Activity</div>
													<div class="w-25">Cateogory</div>
													<!-- <div class="w-15">Duration</div> -->
												</div>
												<div
													class="overflow-auto"
													style="height: calc(100% - 105px);"
												>
													<div
														v-for="(item, index) in logData.logs"
														:key="index"
														class="es-instance-tablebody font-mont fw-500 fs-14 color-434f5e d-flex align-items-center"
													>
														<div
															class="w-25 fw-700 color-84A3FE pointer"
															@click="
																syncWithVideo(
																	item.timeStampInVideo
																		? item.timeStampInVideo
																		: item.timestampInVideo
																)
															"
														>
															{{
																item.timeStampInVideo
																	? item.timeStampInVideo
																	: item.timestampInVideo
															}}
														</div>
														<div class="w-50 pr-2 text-truncate">
															{{ logData.description }}
														</div>
														<div class="w-25 pr-2 text-truncate">
															{{ item.type }}
														</div>
														<!-- <div class="w-15 fw-600 color-green">
															<img
																src="../../assets/newimgs/instancetime.svg"
																alt=""
															/>
															<span class="ml-2">24 sec</span>
														</div> -->
													</div>
												</div>
											</section>
										</section>
									</div>
								</section>
							</section>
							<section
								v-if="selectedAttempt.attemptNo == index + 1"
								id="section-3"
								class="position-sticky top-0 z-1 py-3"
								style="	height: calc(100vh - 70px);background:#e8ebee ;"
							>
								<section
									class="es-third-top-container"
									:class="[
										selectedAttempt.remarks &&
										selectedAttempt.remarks.length > 0
											? ''
											: 'es-third-container-nofdbck',
										selectedAttempt.isSubmitted &&
										(!selectedAttempt.sandboxResults ||
											selectedAttempt.sandboxResults.length == 0)
											? 'mt-4'
											: '',
									]"
								>
									<h5 class="fw-500 fs-14 font-poppins color-72738e">
										Feedback
									</h5>
									<section
										v-if="
											selectedAttempt.remarks &&
												selectedAttempt.remarks.length > 0
										"
									>
										<div
											class="es-fbck-answer-container mb-3 fs-12 fw-400 font-poppins color-6D6D6D"
										>
											<span v-if="selectedAttempt.remarks[3].answer.length > 0"
												>{{ selectedAttempt.remarks[3].answer }}
											</span>
											<span v-else>
												No feedback remarks were given
											</span>
										</div>

										<!-- the below design contact chaitra b after integrating becoz
										shuld change to new design -->
										<section
											class="d-flex align-items-center justify-content-between"
										>
											<div>
												<h6 class="fw-400 fs-12 font-poppins color-464667">
													Question Pattern
												</h6>
												<b-form-rating
													id="rating-lg"
													size="md"
													class="rating-input w-50 p-0"
													v-model="selectedAttempt.remarks[0].answer"
													disabled
												></b-form-rating>
											</div>
											<div>
												<h6 class="fw-400 fs-12 font-poppins color-464667">
													Time allocated for the test
												</h6>
												<b-form-rating
													id="rating-lg"
													size="md"
													class="rating-input w-50 p-0"
													v-model="selectedAttempt.remarks[1].answer"
													disabled
												></b-form-rating>
											</div>
											<div>
												<h6 class="fw-400 fs-12 font-poppins color-464667">
													Overall Experience
												</h6>
												<b-form-rating
													id="rating-lg"
													size="md"
													class="rating-input w-50 p-0"
													v-model="selectedAttempt.remarks[2].answer"
													disabled
												></b-form-rating>
											</div>
										</section>
									</section>
									<div
										class=" d-flex align-items-center flex-column justify-content-center"
										v-else
									>
										<img src="../../assets/newimgs/emptyfdbck.svg" alt="" />
										<h6
											class="mb-0 mt-1 fw-400 fs-13 color-72738e font-poppins"
										>
											No feedback by the candidate
										</h6>
									</div>
								</section>

								<section class="w-100 d-flex gap-3 mt-3">
									<section class="w-50">
										<div class="es-third-bottom1-container w-100 py-3 px-3">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<h6 class="font-inter fs-16 fw-600 color-white">
													Communication Test Result
												</h6>
												<img src="../../assets/newimgs/hire3xai.svg" alt="" />
											</div>
											<div class="w-100 d-flex gap-3 mt-2">
												<div class="es-third-bottom1-boxes w-25">
													<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
														Total attempts:
													</h6>
													<h4
														class="fw-700 fs-24 font-inter mb-0 mt-3"
														:class="
															!selectedAttempt.communicationTest
																? 'color-B8BAC7'
																: 'color-72738e'
														"
													>
														{{
															selectedAttempt.communicationTest
																? selectedAttempt.communicationTest
																		.communicationTestResponse
																		.communicationTestAttemptNo
																: "N/A"
														}}
													</h4>
												</div>
												<div class="es-third-bottom1-boxes w-25">
													<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
														Grammar Acc.
													</h6>
													<h4
														class="fw-700 fs-24 font-inter color-72738e mb-0 mt-3"
														:class="
															!selectedAttempt.communicationTest
																? 'color-B8BAC7'
																: 'color-72738e'
														"
													>
														{{
															selectedAttempt.communicationTest &&
															selectedAttempt.communicationTest
																.communicationTestResponse.analysisResult
																.grammerAccuracy
																? selectedAttempt.communicationTest
																		.communicationTestResponse.analysisResult
																		.grammerAccuracy + "%"
																: "N/A"
														}}
													</h4>
												</div>
												<div class="w-50 d-flex es-third-bottom1-boxes p-0">
													<div class="w-50 p-3">
														<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
															Confidence Level:
														</h6>
														<div
															v-if="selectedAttempt.communicationTest"
															:style="
																getBackgroundColor(
																	selectedAttempt.communicationTest
																		.overallConfidenceText
																)
															"
															class="mt-1 amazing-tag font-mont fw-700 fs-16 color-white"
														>
															{{
																selectedAttempt.communicationTest.overallConfidenceText
																	.split(" ")[0]
																	.toUpperCase()
															}}
														</div>
														<div
															class="mt-1 amazing-tag font-inter fw-700 fs-24 color-B8BAC7"
															v-else
														>
															N/A
														</div>
													</div>
													<div
														class="d-flex justify-content-end w-50 align-items-end pr-1"
													>
														<img
															v-if="selectedAttempt.communicationTest"
															:src="
																getConfideneceImage(
																	selectedAttempt.communicationTest
																		.overallConfidenceText
																)
															"
															alt=""
														/>
														<img
															v-else
															:src="getConfideneceImage('N/A')"
															alt=""
														/>
													</div>
												</div>
											</div>
										</div>
										<div
											class="es-third-bottom2-container w-100 px-2 py-3"
											:class="
												selectedAttempt.remarks &&
												selectedAttempt.remarks.length > 0
													? ''
													: 'es-third-bottom2-container-nofdbck'
											"
										>
											<template v-if="selectedAttempt.communicationTest">
												<div class="w-100 gap-2 d-flex">
													<div class="w-50">
														<h6 class="color-464667 fs-12 fw-500 font-inter">
															Keywords Used:
														</h6>
														<div class="h-135px overflow-auto w-100">
															<!-- hide mt-2 for first index -->
															<div
																class="es-third-keywords-container pr-1 d-flex align-items-center justify-content-between mt-2"
																v-for="(num, keyword) in selectedAttempt
																	.communicationTest.communicationTestResponse
																	.keyWordRepeatingCount"
																:key="keyword"
															>
																<div
																	class="font-poppins fw-400 fs-12 color-6D6D6D"
																>
																	{{ keyword }}
																</div>
																<div
																	class="font-poppins fw-400 fs-12 color-6D6D6D"
																>
																	<span class="fw-600">{{ num }} </span>Times
																</div>
															</div>
														</div>
													</div>
													<div
														class="w-50 h-160px overflow-hidden communication-img-container d-flex align-items-center justify-content-center"
													>
														<img
															:src="
																selectedAttempt.communicationTest
																	.communicationTestResponse.mediaResource[0]
																	.mediaLink
															"
															class="h-100 overflow-hidden"
															alt=""
														/>
													</div>
												</div>
												<div
													class="d-flex align-items-center justify-content-between"
												>
													<h6 class="color-464667 mb-0 fs-12 fw-500 font-inter">
														Candidate Answer is
													</h6>
													<div
														class="font-poppins fs-11 fw-400 color-72738e d-flex align-items-center"
													>
														Hear the Answer
														<audio id="audioPlayer" ref="audioRef"></audio>
														<span @click="toggleAudio()" class="mx-2 pointer">
															<img
																v-if="isPlaying"
																src="../../assets/newimgs/hearanswer.svg"
																alt=""
															/>
															<img
																v-else
																src="../../assets/newimgs/nothear.svg"
																alt=""
															/>
														</span>
														<div class="waveform" @click="seekTimeline($event)">
															<div
																v-for="(bar, index) in waveformData"
																:key="index"
																class="wave-bar"
																:style="{
																	'--bar-height': bar + 'px',
																	backgroundColor:
																		index <= currentBar ? '#28a745' : '#ccc',
																}"
															></div>
														</div>
													</div>
												</div>
												<div
													v-if="
														selectedAttempt.communicationTest
															.communicationTestResponse.analysisResult
															.textConverted
													"
													class="mt-3 es-ct-answer-container font-poppins fs-12 fw-400 color-6D6D6D"
												>
													{{
														selectedAttempt.communicationTest
															.communicationTestResponse.analysisResult
															.textConverted
													}}
												</div>
											</template>
											<template v-else>
												<div
													class=" d-flex align-items-center flex-column justify-content-center h-100"
												>
													<img
														src="../../assets/newimgs/emptytypingtest.svg"
														alt=""
													/>
													<h6
														class="mb-0 mt-1 fw-400 fs-13 color-72738e font-poppins"
													>
														No test data found
													</h6>
												</div>
											</template>
										</div>
									</section>
									<!-- <section class="w-50" v-else>
										<div>No Communication Test</div>
									</section> -->
									<section class="w-50">
										<div class="es-third-bottom1-container w-100 py-3 px-3">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<h6 class="font-inter fs-16 fw-600 color-white">
													Typing Test Result
												</h6>
												<img src="../../assets/newimgs/hire3xai.svg" alt="" />
											</div>
											<div class="w-100 d-flex gap-3 mt-2">
												<div class="es-third-bottom1-boxes w-33">
													<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
														Typing Speed
													</h6>
													<h4
														class="fw-700 fs-24 font-inter color-72738e mb-0 mt-3"
														:class="
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.wpm
																? 'color-72738e'
																: 'color-B8BAC7'
														"
													>
														{{
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.wpm
																? selectedAttempt.typingTest.analysisResult
																		.wpm + " WPM"
																: "N/A"
														}}
													</h4>
												</div>
												<div class="es-third-bottom1-boxes w-33">
													<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
														Accuracy
													</h6>
													<h4
														class="fw-700 fs-24 font-inter color-72738e mb-0 mt-3"
														:class="
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.accuracy
																? 'color-72738e'
																: 'color-B8BAC7'
														"
													>
														{{
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.accuracy
																? selectedAttempt.typingTest.analysisResult
																		.accuracy + "%"
																: "N/A"
														}}
													</h4>
												</div>
												<div class="es-third-bottom1-boxes w-34">
													<h6 class="color-6D6D6D fw-500 fs-14 font-inter">
														Mistakes
													</h6>
													<h4
														class="fw-700 fs-24 font-inter mb-0 mt-3"
														:class="
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.mistakes
																? 'color-72738e'
																: 'color-B8BAC7'
														"
													>
														{{
															selectedAttempt.typingTest &&
															selectedAttempt.typingTest.analysisResult.mistakes
																? selectedAttempt.typingTest.analysisResult
																		.mistakes
																: "N/A"
														}}
													</h4>
												</div>
											</div>
										</div>
										<div
											class="es-third-bottom2-container w-100 p-3"
											:class="
												selectedAttempt.remarks &&
												selectedAttempt.remarks.length > 0
													? ''
													: 'es-third-bottom2-container-nofdbck'
											"
										>
											<template v-if="selectedAttempt.typingTest">
												<div class="es-tt-question-container w-100 p-3">
													<h6 class="color-464667 fs-12 fw-500 font-inter">
														Question:
													</h6>
													<div
														class="mt-2 color-6D6D6D fs-12 fw-400 font-poppins"
													>
														{{ selectedAttempt.typingTest.paragraph }}
													</div>
												</div>
												<div class="mt-3 w-100">
													<h6 class="color-464667 fs-12 fw-400 font-poppins">
														Candidate Answer is :
													</h6>
													<div
														style="max-height: 48%;min-height: 100px;"
														class="mt-2 es-ct-answer-container font-poppins fs-12 fw-400 color-6D6D6D"
													>
														{{
															selectedAttempt.typingTest.analysisResult.answer
																? selectedAttempt.typingTest.analysisResult
																		.answer
																: "--"
														}}
													</div>
												</div>
											</template>
											<template v-else>
												<div
													class=" d-flex align-items-center flex-column justify-content-center h-100"
												>
													<img
														src="../../assets/newimgs/emptytypingtest.svg"
														alt=""
													/>
													<h6
														class="mb-0 mt-1 fw-400 fs-13 color-72738e font-poppins"
													>
														No test data found
													</h6>
												</div>
											</template>
										</div>
									</section>
								</section>
							</section>
							<section
								v-if="
									(!selectedAttempt.sandboxResults ||
										Object.keys(selectedAttempt.sandboxResults).length === 0) &&
										selectedAttempt.attemptNo == index + 1
								"
								id="section-4"
								class="position-sticky top-0 z-1 py-3 es-last-section-tabs"
								style="	height: calc(100vh - 70px);background:#e8ebee ;top: 70px;"
							>
								<section
									class="d-flex align-items-center w-100 justify-content-between mt-3"
								>
									<h5 class="fw-600 fs-16 font-poppins color-464667">
										Evaluate Assessment
									</h5>
									<!-- selectedAttempt.isSubmitted -->
									<div class="d-flex align-items-center gap-3">
										<div
											class="negativemark-container fw-500 fs-13 font-poppins color-72738e"
										>
											Allocated Negative Mark Range for this test is:
											<span class="color-red">
												{{ selectedAttempt.negativeMark }}
											</span>
										</div>
										<div
											class="evaluated-boxes fw-500 fs-13 font-poppins color-72738e"
										>
											Evaluation :
											<span
												:class="
													selectedAttempt.evaluation
														? 'color-green'
														: 'color-red'
												"
												>{{ getEvaluationText(selectedAttempt) }}</span
											>
										</div>
									</div>
								</section>
								<div>
									<b-tabs>
										<b-tab
											v-if="allQuestions.length"
											active
											@click="activeTab = 1"
										>
											<template #title>
												<span>
													<img
														v-if="activeTab === 1"
														src="../../assets/newimgs/activesection.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													<img
														v-else
														src="../../assets/newimgs/inactivesection.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													Sections
												</span>
											</template>
											<div
												class="es-section-container-tabs h-100 smalltabs"
												:class="{
													'es-section-empty-container-tabs': !selectedAttempt.isSubmitted,
												}"
											>
												<b-tabs pills card>
													<b-tab
														v-for="(section, index) in allQuestions"
														:key="index"
														:active="n === 1"
														class="pt-3"
														@click="selectedSection = section"
													>
														<template #title>
															<span class="text-truncate">
																{{ section.sectionName }}
																<img
																	v-if="n === 3"
																	src="../../assets/icons/proctoring/priorityicon.svg"
																	alt=""
																	class="ml-1"
																	style="margin-top: -3px;"
																/>
															</span>
														</template>
														<div
															class="h-100"
															v-if="!selectedAttempt.isSubmitted"
														>
															<div
																class=" h-100 d-flex align-items-center justify-content-center w-100 flex-column"
															>
																<img
																	src="../../assets/newimgs/nocommutest.svg"
																	alt=""
																/>
																<div
																	class="fw-400 fs-16 font-poppins color-72738e mt-3"
																>
																	No test data found
																</div>
															</div>
														</div>
														<div class="d-flex flex-column gap-3" v-else>
															<div
																class="es-answercard position-relative"
																v-for="(question,
																index) in selectedSection.sectionResponse"
																:key="index"
															>
																<div
																	:style="getBackground(question)"
																	class="gridgreencolorDynamic"
																></div>
																<h6
																	class="pl-2 font-poppins fs-12 fw-600 color-72738e"
																>
																	{{ getTitle(question) }}
																</h6>

																<div
																	class="pl-2 d-flex justify-content-between mt-3"
																>
																	<div
																		class="w-85"
																		v-if="
																			question.questionKey.slice(0, 3) == 'MCQ'
																		"
																	>
																		<div class="w-100">
																			<video
																				v-if="
																					isAudio(
																						question.questionBody
																							.questionMediaType
																					) ||
																						isVideo(
																							question.questionBody
																								.questionMediaType
																						)
																				"
																				controls
																				:src="
																					question.questionBody.questionMedia
																				"
																				:class="
																					isAudio(
																						question.questionBody
																							.questionMediaType
																					)
																						? 'audio-card mb-3'
																						: 'video-card mb-3'
																				"
																			></video>
																			<img
																				class="image-card mb-3"
																				v-if="
																					isImage(
																						question.questionBody
																							.questionMediaType
																					)
																				"
																				:src="
																					question.questionBody.questionMedia
																				"
																				alt=""
																			/>
																			<div class="d-flex">
																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e pr-1"
																				>
																					Q{{ index + 1 }}.
																				</h6>

																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e w-100 mb-0"
																					v-html="
																						question.questionBody.question
																					"
																				></h6>
																			</div>
																			<b-row class="">
																				<b-col
																					class="mt-3"
																					:cols="hasAllMedia(question) ? 4 : 6"
																					v-for="(options, index) in question
																						.questionBody.options"
																					:key="index"
																				>
																					<div
																						class="es-checkbox"
																						v-if="
																							question.questionBody
																								.noOfCorrectOptionsAllowed > 1
																						"
																					>
																						<b-form-checkbox
																							:value="
																								options.value
																									? options.value
																									: options.mediaValue
																							"
																							v-model="question.answer"
																							:checked="
																								options.value ||
																									options.mediaValue ==
																										question.answer
																							"
																							disabled
																						>
																							<span
																								v-if="options.value"
																								class="font-poppins fs-13 fw-400 color-72738e"
																							>
																								{{ options.value }}</span
																							>
																							<span v-if="options.media"
																								><span
																									class="uploaded-option-imagecard"
																								>
																									<img
																										:src="options.media"
																										alt=""
																										class="w-100 h-100 overflow-hidden"
																										style="border-radius: 4px;"
																									/>
																								</span>
																							</span>
																						</b-form-checkbox>
																					</div>
																					<div class="mob-radio-group" v-else>
																						<b-form-radio
																							:value="
																								options.value
																									? options.value
																									: options.mediaValue
																							"
																							v-model="question.answer"
																							:checked="
																								options.value ||
																									options.mediaValue ==
																										question.answer
																							"
																							disabled
																							><span
																								v-if="options.value"
																								class="font-poppins fs-13 fw-400 color-72738e"
																							>
																								{{ options.value }}</span
																							>
																							<span v-if="options.media"
																								><span
																									class="uploaded-option-imagecard"
																								>
																									<img
																										:src="options.media"
																										alt=""
																										class="w-100 h-100 overflow-hidden"
																										style="border-radius: 4px;"
																									/>
																								</span> </span
																						></b-form-radio>
																					</div>
																				</b-col>
																			</b-row>
																			<!-- <div
																				v-if="
																					showAnswer == question.questionKey
																				"
																				class="ans-text mt-2"
																			>
																				Answer:
																				{{ question.answer }}
																			</div> -->
																		</div>
																	</div>
																	<!-- desc -->
																	<div
																		class="w-85"
																		v-if="
																			question.questionKey.slice(0, 3) == 'LON'
																		"
																	>
																		<div class="w-100">
																			<video
																				v-if="
																					isAudio(
																						question.questionBody
																							.questionMediaType
																					) ||
																						isVideo(
																							question.questionBody
																								.questionMediaType
																						)
																				"
																				controls
																				:src="
																					question.questionBody.questionMedia
																				"
																				:class="
																					isAudio(
																						question.questionBody
																							.questionMediaType
																					)
																						? 'audio-card mb-3'
																						: 'video-card mb-3'
																				"
																			></video>
																			<img
																				class="image-card mb-3"
																				v-if="
																					isImage(
																						question.questionBody
																							.questionMediaType
																					)
																				"
																				:src="
																					question.questionBody.questionMedia
																				"
																				alt=""
																			/>
																			<div class="d-flex">
																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e pr-1"
																				>
																					Q{{ index + 1 }}.
																				</h6>
																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e w-100"
																					v-html="
																						question.questionBody.question
																					"
																				></h6>
																			</div>
																			<b-row>
																				<b-col cols="6">
																					<b-form-textarea
																						v-model="question.answer"
																						disabled
																					></b-form-textarea>
																				</b-col>
																			</b-row>
																		</div>
																		<!-- mtf -->
																		<!-- desc -->
																	</div>
																	<div
																		class="w-85"
																		v-if="
																			question.questionKey.slice(0, 3) == 'MAF'
																		"
																	>
																		<div class="w-100">
																			<div class="d-flex">
																				<video
																					v-if="
																						isAudio(
																							question.questionBody
																								.questionMediaType
																						) ||
																							isVideo(
																								question.questionBody
																									.questionMediaType
																							)
																					"
																					controls
																					:src="
																						question.questionBody.questionMedia
																					"
																					:class="
																						isAudio(
																							question.questionBody
																								.questionMediaType
																						)
																							? 'audio-card mb-3'
																							: 'video-card mb-3'
																					"
																				></video>
																				<img
																					class="image-card mb-3"
																					v-if="
																						isImage(
																							question.questionBody
																								.questionMediaType
																						)
																					"
																					:src="
																						question.questionBody.questionMedia
																					"
																					alt=""
																				/>
																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e pr-1"
																				>
																					Q{{ index + 1 }}.
																				</h6>

																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e w-100"
																					v-html="
																						question.questionBody.question
																					"
																				></h6>
																			</div>
																			<b-row
																				class="mb-2 mx-0 es-mtf-optionmain d-flex align-items-stretch"
																				v-for="(option, index) in question
																					.questionBody.actualAnswer"
																				:key="index"
																			>
																				<b-col class="pl-0 d-flex">
																					<div
																						:class="
																							question.answer &&
																							option.sideB ==
																								question.answer[index]
																								? 'es-mtf-crctoption'
																								: 'es-mtf-wrongoption'
																						"
																						class="fw-500 fs-11 font-poppins color-72738e w-100"
																					>
																						{{ option.sideA }}
																					</div>
																				</b-col>
																				<b-col class="px-0 d-flex">
																					<div
																						class="w-100 fw-500 fs-11 font-poppins color-72738e d-flex"
																					>
																						<div class="mr-2 mt-1">
																							<img
																								src="../../assets/newimgs/sixdots.svg"
																								alt=""
																								style="vertical-align: top;"
																							/>
																						</div>
																						<div>
																							{{
																								(question.answer &&
																									question.answer[index]) ||
																									"--"
																							}}
																						</div>
																					</div>
																				</b-col>
																			</b-row>
																		</div>

																		<!-- mtf -->
																		<!-- desc -->
																	</div>
																	<div class="w-15">
																		<div
																			class="w-100 d-flex justify-content-end align-items-end flex-column"
																		>
																			<div
																				class="topDiv position-realtive d-flex align-items-center givemark vcps"
																			>
																				<label
																					class="fieldsetStyle fw-400 fs-9 font-poppins color-696969"
																					style="z-index: 8"
																					>Give Marks &nbsp;<span
																						class="asterik"
																						>*</span
																					></label
																				>
																				<b-form-input
																					:disabled="
																						!selectedAttempt.markingCheck
																					"
																					class="vcp-inputField no-spinner"
																					type="number"
																					:class="
																						invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																							? 'error'
																							: ''
																					"
																					placeholder="Enter"
																					@input="
																						updateMarks(
																							question,
																							$event,
																							section
																						)
																					"
																					v-model="question.questionMarks"
																					@wheel.prevent
																				></b-form-input>
																				<div
																					v-if="
																						invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																					"
																					class="es-eval-validationicon"
																					variant="primary"
																					v-b-popover.hover.v-danger="{
																						content: invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																							? invalidMarks[
																									`${section.sectionID}_${question.questionKey}`
																							  ].reason
																							: '',
																					}"
																				>
																					<img
																						src="../../assets/deletepopupicon.svg"
																						alt=""
																					/>
																				</div>
																				/{{ question.questionBody.marks }}
																			</div>
																			<div
																				v-if="
																					question.questionKey.slice(0, 3) !=
																						'LON'
																				"
																				@click="
																					toggleAnswer(question.questionKey)
																				"
																				class="es-showanswer mt-3 font-poppins fs-13 fw-400 color-2E425D text-center pointer"
																			>
																				{{
																					showAnswer === question.questionKey
																						? "Hide answer"
																						: "Show answer"
																				}}
																			</div>
																		</div>
																	</div>
																</div>
																<template
																	v-if="
																		showAnswer === question.questionKey &&
																			question.questionKey.slice(0, 3) == 'MAF'
																	"
																>
																	<div class="grey-dotted-hr my-3 ml-2"></div>
																	<div
																		class="es-answer-box-container position-relative d-flex align-items-center ml-2"
																	>
																		<h6
																			class="w-5 mb-0 fw-600 font-poppins fs-12 color-72738e"
																		>
																			Answer
																		</h6>
																		<div
																			class="vertical-answer-line mx-2"
																		></div>
																		<section class="w-95 ml-3">
																			<div
																				v-for="(option, index) in question
																					.questionBody.actualAnswer"
																				:key="'ans-' + index"
																				class="w-100 d-flex align-items-center mt-2"
																			>
																				<div
																					class="es-mtf-answer-option w-48 fw-500 fs-11 font-poppins color-72738e"
																				>
																					{{ option.sideA }}
																				</div>
																				<img
																					src="../../assets/newimgs/greenarw.svg"
																					alt=""
																					class="mx-2"
																				/>
																				<div
																					class="es-mtf-answer-option w-48 fw-500 fs-11 font-poppins color-72738e"
																				>
																					{{ option.sideB }}
																				</div>
																			</div>
																		</section>
																	</div>
																</template>
																<template
																	v-if="
																		showAnswer == question.questionKey &&
																			question.questionKey.slice(0, 3) == 'MCQ'
																	"
																>
																	<div class="grey-dotted-hr my-3 ml-2"></div>
																	<div
																		class="position-relative es-answer-box-container d-flex align-items-center ml-2"
																	>
																		<h6
																			class="mb-0 fw-600 font-poppins fs-12 color-72738e"
																		>
																			Answer
																		</h6>
																		<div
																			style="top: 7px;left: 70px;"
																			class="vertical-answer-line mx-2"
																		></div>
																		<section
																			class="d-flex flex-column gap-3 ml-3"
																		>
																			<template
																				v-for="(options, index) in question
																					.questionBody.options"
																			>
																				<div
																					v-if="options.check"
																					:key="index"
																					class="d-flex align-items-center"
																				>
																					<div
																						class="es-answer-optiontag ml-1 fw-500 font-poppins color-white fs-12 text-center"
																					>
																						Option {{ index + 1 }}
																					</div>
																					<h6
																						class="mb-0 ml-3 fw-400 font-poppins fs-13 color-72738e"
																					>
																						<span v-if="options">
																							{{ options.value }}
																						</span>
																						<span v-if="options.media">
																							<span
																								class="uploaded-option-imagecard"
																							>
																								<img
																									:src="options.media"
																									alt=""
																									class="w-100 h-100 overflow-hidden"
																									style="border-radius: 4px;"
																								/>
																							</span>
																						</span>
																					</h6>
																				</div>
																			</template>
																		</section>
																	</div>
																</template>
															</div>
														</div>
													</b-tab>
												</b-tabs>
											</div>
										</b-tab>
										<b-tab v-if="codingquestions.length" @click="activeTab = 2">
											<template #title>
												<span>
													<img
														v-if="activeTab != 2"
														src="../../assets/newimgs/inactivecodingtest.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													<img
														v-else
														src="../../assets/newimgs/activecodingtest.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													Coding Test
												</span>
											</template>
											<div
												:class="{
													'es-section-empty-container-tabs': !selectedAttempt.isSubmitted,
												}"
												class="es-codingsection es-section-container-tabs h-100 smalltabs"
											>
												<b-tabs pills card>
													<b-tab
														v-for="(section, index) in codingquestions"
														:key="index"
														:active="n === 1"
														class="pt-3"
														@click="selectedCodeSection = section"
													>
														<template #title>
															<span class="text-truncate">
																Programming {{ index + 1 }}
																<!-- <img
																	v-if="n === 3"
																	src="../../assets/icons/proctoring/priorityicon.svg"
																	alt=""
																	class="ml-1"
																	style="margin-top: -3px;"
																/> -->
															</span>
														</template>
														<div class="d-flex flex-column gap-3">
															<div
																class="es-answercard position-relative"
																v-for="(question,
																index) in selectedCodeSection.sectionResponse"
																:key="index"
															>
																<div
																	:style="getBackground(question)"
																	class="gridgreencolorDynamic"
																></div>
																<h6
																	class="pl-2 font-poppins fs-12 fw-600 color-72738e"
																>
																	Programming {{ index + 1 }}
																</h6>
																<div
																	class="pl-2 d-flex justify-content-between mt-3"
																>
																	<!-- desc -->
																	<div class="w-85">
																		<div class="w-100">
																			<div class="d-flex">
																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e pr-1"
																				>
																					Q{{ index + 1 }}.
																				</h6>

																				<h6
																					class="lh-21 font-poppins fs-13 fw-400 color-72738e w-100"
																					v-html-safe="
																						question.questionBody.question
																					"
																				></h6>
																			</div>
																		</div>
																		<!-- mtf -->
																		<!-- desc -->
																	</div>
																	<div class="w-15">
																		<div
																			class="w-100 d-flex justify-content-end align-items-end flex-column"
																		>
																			<div
																				class="topDiv d-flex relativeclass align-items-center givemark vcps"
																			>
																				<label
																					class="fieldsetStyle"
																					style="z-index: 8"
																					>Give Marks &nbsp;<span
																						class="asterik"
																						>*</span
																					></label
																				>
																				<b-form-input
																					:disabled="
																						!selectedAttempt.markingCheck
																					"
																					:class="
																						invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																							? 'error'
																							: ''
																					"
																					class="vcp-inputField no-spinner fw-400 fs-9 font-poppins color-696969"
																					type="number"
																					placeholder="Enter"
																					@input="
																						updateMarks(
																							question,
																							$event,
																							section
																						)
																					"
																					v-model="question.questionMarks"
																					@wheel.prevent
																				></b-form-input>
																				<div
																					v-if="
																						invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																					"
																					v-b-popover.hover.v-danger="{
																						content: invalidMarks[
																							`${section.sectionID}_${question.questionKey}`
																						]
																							? invalidMarks[
																									`${section.sectionID}_${question.questionKey}`
																							  ].reason
																							: '',
																					}"
																					class="es-eval-validationicon"
																					variant="primary"
																				>
																					<img
																						src="../../assets/deletepopupicon.svg"
																						alt=""
																					/>
																				</div>
																				/{{ question.questionBody.marks }}
																			</div>
																			<div
																				v-if="question.answerStatus.attempted"
																				@click="
																					showCodingAnswer(question, section)
																				"
																				class="es-showanswer mt-3 font-poppins fs-13 fw-400 color-2E425D text-center pointer"
																			>
																				Show Answer
																			</div>
																			<div
																				v-else
																				class="es-showanswer mt-3 font-poppins fs-13 fw-400 color-2E425D text-center disablecursor"
																			>
																				Not answered
																			</div>
																		</div>
																	</div>
																</div>
																<!-- <div class="grey-dotted-hr my-3 ml-2"></div> -->
																<div
																	v-if="
																		showAnswer == question.questionKey &&
																			question.questionKey.slice(0, 3) == 'MCQ'
																	"
																	class="es-answer-box-container d-flex align-items-center ml-2"
																>
																	<h6
																		class="mb-0 fw-600 font-poppins fs-12 color-72738e"
																	>
																		Answer
																	</h6>
																	<img
																		src="../../assets/newimgs/answerline.svg"
																		class="mx-2"
																		alt=""
																	/>
																	<div
																		class="es-answer-optiontag ml-1 fw-500 font-poppins color-white fs-12 text-center"
																	>
																		Option
																		{{
																			question.questionBody.options.findIndex(
																				(opt) => opt.value === question.answer
																			) + 1
																		}}
																	</div>
																	<h6
																		class="mb-0 ml-3 fw-400 font-poppins fs-13 color-72738e"
																	>
																		{{ question.answer }}
																	</h6>
																</div>
															</div>
														</div>
													</b-tab>
												</b-tabs>
											</div>
										</b-tab>
										<b-tab
											@click="activeTab = 3"
											v-if="communicationQuestions.length"
										>
											<template #title>
												<span>
													<img
														v-if="activeTab != 3"
														src="../../assets/newimgs/inactivecommu.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													<img
														v-else
														src="../../assets/newimgs/activecommu.svg"
														alt=""
														class="mr-1"
														style="margin-top: -3px;"
													/>
													Communication Section
												</span>
											</template>
											<div
												:class="{
													'es-section-empty-container-tabs': !selectedAttempt.isSubmitted,
												}"
												class="es-codingsection es-section-container-tabs h-100 smalltabs pt-0"
											>
												<b-tabs pills card>
													<b-tab
														v-for="(section,
														secIndex) in communicationQuestions"
														:key="secIndex"
														:active="n === 1"
														class="pt-3"
														@click="selectCommunicationSection(section)"
													>
														<template #title>
															<span class="text-truncate">
																{{ section.sectionName }}
															</span>
														</template>
														<div
															class="h-100"
															v-if="!selectedAttempt.isSubmitted"
														>
															<div
																class=" h-100 d-flex align-items-center justify-content-center w-100 flex-column"
															>
																<img
																	src="../../assets/newimgs/nocommutest.svg"
																	alt=""
																/>
																<div
																	class="fw-400 fs-16 font-poppins color-72738e mt-3"
																>
																	No test data found
																</div>
															</div>
														</div>
														<div
															class="h-100"
															v-else-if="section.comuSectionEvaluated === false"
														>
															<div
																class=" h-100 d-flex align-items-center justify-content-center w-100 flex-column"
															>
																<img
																	src="../../assets/newimgs/nocommutest.svg"
																	alt=""
																/>
																<div
																	class="fw-400 fs-16 font-poppins color-72738e mt-3"
																>
																	The Communication Test results are currently
																	being processed. Please check back shortly.
																</div>
															</div>
														</div>
														<div
															v-else
															class="es-ct-mainscreen px-0 pt-0"
															:ref="'scrollContainer_' + secIndex"
														>
															<section
																class="es-communication-card position-relative"
															>
																<section
																	class="d-flex justify-content-between w-100 gap-4"
																>
																	<section class=" w-40">
																		<div
																			class="d-flex align-items-center es-greyheader fs-16 fw-600 font-mont color-656565"
																		>
																			Video Recording
																		</div>

																		<div class="es-ct-vrbox mt-3">
																			<div
																				:ref="'videoContainer_' + secIndex"
																				class="video-wrapper"
																				:class="{
																					mini: isMiniMap[secIndex],
																					animating: isAnimatingMap[secIndex],
																					'h-100 w-100': !isMiniMap[secIndex],
																				}"
																			>
																				<div
																					class="video-inner position-relative"
																					:class="{
																						'h-100 w-100': !isMiniMap[secIndex],
																					}"
																				>
																					<video
																						:ref="'commVideo_' + secIndex"
																						:src="currentCommVideoPath"
																						controls
																						controlsList="nodownload noplaybackrate"
																						playsinline
																						class="w-100 h-100 br13px"
																						@pause="onVideoPause(secIndex)"
																						@play="onCommVideoPlay(secIndex)"
																						@seeking="onVideoSeeking(secIndex)"
																						@seeked="onVideoSeeked(secIndex)"
																					/>
																					<img
																						src="@/assets/videoclose.svg"
																						alt=""
																						class="position-absolute pointer"
																						style="top: 5px;right: 10px;"
																						v-if="isMiniMap[secIndex]"
																						@click.stop="
																							restoreVideoToOriginal(secIndex)
																						"
																					/>
																				</div>
																			</div>
																		</div>
																		<div
																			:ref="'floatTrigger_' + secIndex"
																		></div>
																	</section>
																	<div
																		class="my-3 grey-dotted-hr es-vertical-line"
																		style="left: 40.5%;top: 6px;height: 365px;"
																	></div>

																	<section class="w-60">
																		<div
																			class="d-flex align-items-center es-greyheader justify-content-between "
																		>
																			<div
																				class="fs-16 fw-600 font-mont color-656565"
																			>
																				Overall Result
																			</div>
																			<div class="d-flex align-items-center">
																				<div
																					class="color-72738e fs-14 fw-500 font-lato"
																				>
																					Total Questions:
																					{{
																						selectedCommunicationSEction
																							.sectionResponse.length
																					}}
																				</div>
																				<div class="es-ta-line mx-2"></div>
																				<div
																					class="color-72738e fs-14 fw-500 font-lato"
																				>
																					To be answered:
																					{{
																						selectedCommunicationSEction.noOfQuestionsToAnswer
																					}}
																				</div>
																			</div>
																		</div>
																		<div
																			class="es-ct-greenbox d-flex gap-3 mt-3"
																			:class="[
																				isCommunicationNotAttempted(section)
																					? 'bg-matte-7a7a7a border-7a7a7a'
																					: section.sectionMarks <=
																					  section.serctionTotalMarks / 4
																					? 'bg-matte-red border-red'
																					: section.sectionMarks <=
																					  (section.serctionTotalMarks / 4) * 2
																					? 'bg-matte-orange border-orange'
																					: section.sectionMarks <=
																					  (section.serctionTotalMarks / 4) * 3
																					? 'bg-matte-yellow border-yellow'
																					: 'bg-matte-green border-green',
																			]"
																		>
																			<div
																				class="esctgb-rating color-white fw-700 fs-20 font-mont px-1"
																				:class="[
																					isCommunicationNotAttempted(section)
																						? 'bg-7a7a7a'
																						: section.sectionMarks <=
																						  section.serctionTotalMarks / 4
																						? 'bg-red'
																						: section.sectionMarks <=
																						  (section.serctionTotalMarks / 4) *
																								2
																						? 'bg-orange'
																						: section.sectionMarks <=
																						  (section.serctionTotalMarks / 4) *
																								3
																						? 'bg-yellow'
																						: 'bg-green',
																				]"
																			>
																				{{
																					isCommunicationNotAttempted(section)
																						? "NA"
																						: formatSectionMarks(
																								section.sectionMarks
																						  ) +
																						  " / " +
																						  section.serctionTotalMarks
																				}}
																			</div>

																			<div class="w-85">
																				<div
																					class="fw-700 font-mont fs-16 d-flex align-items-center"
																					:class="[
																						isCommunicationNotAttempted(section)
																							? 'color-7a7a7a'
																							: section.sectionMarks <=
																							  section.serctionTotalMarks / 4
																							? 'color-red-progress'
																							: section.sectionMarks <=
																							  (section.serctionTotalMarks /
																									4) *
																									2
																							? 'color-orange-progress'
																							: section.sectionMarks <=
																							  (section.serctionTotalMarks /
																									4) *
																									3
																							? 'color-yellow-progress'
																							: 'color-green-progress',
																					]"
																				>
																					<!-- Show star icon ONLY when green & attempted -->
																					<img
																						v-if="
																							!isCommunicationNotAttempted(
																								section
																							) &&
																								section.sectionMarks >
																									(section.serctionTotalMarks /
																										4) *
																										3
																						"
																						src="@/assets/newimgs/greenstars.svg"
																						class="mr-2"
																						alt="Stars"
																					/>

																					{{ getCommunicationText(section) }}
																				</div>

																				<div
																					class="color-2E425D font-mont fw-400 fs-15 mt-1"
																					v-if="
																						section.overallFeedbacks &&
																							section.overallFeedbacks
																								.generalFeedback
																								.overallAssessment
																					"
																				>
																					{{
																						section.overallFeedbacks
																							.generalFeedback.overallAssessment
																					}}
																				</div>
																			</div>
																		</div>

																		<div
																			class="mt-3 es-progress"
																			v-if="
																				section.overallCommunicationSectionScore
																			"
																		>
																			<!-- Pronunciation -->
																			<div
																				class="d-flex align-items-center justify-content-between mt-2"
																			>
																				<div
																					class="font-poppins fs-14 fw-500 color-464667"
																				>
																					Pronunciation
																				</div>
																				<div
																					class="fs-14 fw-600 font-poppins"
																					:class="
																						`color-${section.overallCommunicationSectionScore.pronunciationScore.color}-progress`
																					"
																				>
																					{{
																						section
																							.overallCommunicationSectionScore
																							.pronunciationScore.score === 0
																							? "NA"
																							: section
																									.overallCommunicationSectionScore
																									.pronunciationScore.score +
																							  "/" +
																							  section
																									.overallCommunicationSectionScore
																									.outOf
																					}}
																				</div>
																			</div>
																			<b-progress
																				:max="
																					section
																						.overallCommunicationSectionScore
																						.outOf
																				"
																				:value="
																					section
																						.overallCommunicationSectionScore
																						.pronunciationScore.score
																				"
																				:variant="
																					getColor(
																						section
																							.overallCommunicationSectionScore
																							.pronunciationScore
																					)
																				"
																			/>

																			<!-- Grammar -->
																			<div
																				class="d-flex align-items-center justify-content-between mt-3"
																			>
																				<div
																					class="font-poppins fs-14 fw-500 color-464667"
																				>
																					Grammar
																				</div>
																				<div
																					class="fs-14 fw-600 font-poppins"
																					:class="
																						`color-${section.overallCommunicationSectionScore.grammarScore.color}-progress`
																					"
																				>
																					{{
																						section
																							.overallCommunicationSectionScore
																							.grammarScore.score === 0
																							? "NA"
																							: section
																									.overallCommunicationSectionScore
																									.grammarScore.score +
																							  "/" +
																							  section
																									.overallCommunicationSectionScore
																									.outOf
																					}}
																				</div>
																			</div>
																			<b-progress
																				:max="
																					section
																						.overallCommunicationSectionScore
																						.outOf
																				"
																				:value="
																					section
																						.overallCommunicationSectionScore
																						.grammarScore.score
																				"
																				:variant="
																					getColor(
																						section
																							.overallCommunicationSectionScore
																							.grammarScore
																					)
																				"
																			/>

																			<!-- Fluency -->
																			<div
																				class="d-flex align-items-center justify-content-between mt-3"
																			>
																				<div
																					class="font-poppins fs-14 fw-500 color-464667"
																				>
																					Fluency
																				</div>
																				<div
																					class="fs-14 fw-600 font-poppins"
																					:class="
																						`color-${section.overallCommunicationSectionScore.fluencyScore.color}-progress`
																					"
																				>
																					{{
																						section
																							.overallCommunicationSectionScore
																							.fluencyScore.score === 0
																							? "NA"
																							: section
																									.overallCommunicationSectionScore
																									.fluencyScore.score +
																							  "/" +
																							  section
																									.overallCommunicationSectionScore
																									.outOf
																					}}
																				</div>
																			</div>
																			<b-progress
																				:max="
																					section
																						.overallCommunicationSectionScore
																						.outOf
																				"
																				:value="
																					section
																						.overallCommunicationSectionScore
																						.fluencyScore.score
																				"
																				:variant="
																					getColor(
																						section
																							.overallCommunicationSectionScore
																							.fluencyScore
																					)
																				"
																			/>

																			<!-- Vocabulary -->
																			<div
																				class="d-flex align-items-center justify-content-between mt-3"
																			>
																				<div
																					class="font-poppins fs-14 fw-500 color-464667"
																				>
																					Vocabulary
																				</div>
																				<div
																					class="fs-14 fw-600 font-poppins"
																					:class="
																						`color-${section.overallCommunicationSectionScore.vocabularyScore.color}-progress`
																					"
																				>
																					{{
																						section
																							.overallCommunicationSectionScore
																							.vocabularyScore.score === 0
																							? "NA"
																							: section
																									.overallCommunicationSectionScore
																									.vocabularyScore.score +
																							  "/" +
																							  section
																									.overallCommunicationSectionScore
																									.outOf
																					}}
																				</div>
																			</div>
																			<b-progress
																				:max="
																					section
																						.overallCommunicationSectionScore
																						.outOf
																				"
																				:value="
																					section
																						.overallCommunicationSectionScore
																						.vocabularyScore.score
																				"
																				:variant="
																					getColor(
																						section
																							.overallCommunicationSectionScore
																							.vocabularyScore
																					)
																				"
																			/>

																			<!-- Relevancy -->
																			<div
																				class="d-flex align-items-center justify-content-between mt-3"
																			>
																				<div
																					class="font-poppins fs-14 fw-500 color-464667"
																				>
																					Relevancy to Topic
																				</div>
																				<div
																					class="fs-14 fw-600 font-poppins"
																					:class="
																						`color-${section.overallCommunicationSectionScore.relatableScore.color}-progress`
																					"
																				>
																					{{
																						section
																							.overallCommunicationSectionScore
																							.relatableScore.score === 0
																							? "NA"
																							: section
																									.overallCommunicationSectionScore
																									.relatableScore.score +
																							  "/" +
																							  section
																									.overallCommunicationSectionScore
																									.outOf
																					}}
																				</div>
																			</div>
																			<b-progress
																				:max="
																					section
																						.overallCommunicationSectionScore
																						.outOf
																				"
																				:value="
																					section
																						.overallCommunicationSectionScore
																						.relatableScore.score
																				"
																				:variant="
																					getColor(
																						section
																							.overallCommunicationSectionScore
																							.relatableScore
																					)
																				"
																			/>
																		</div>
																	</section>
																</section>

																<hr />
																<section
																	class="d-flex align-items-center justify-content-between"
																>
																	<section
																		class="d-flex flex-wrap align-items-center gap-3"
																	>
																		<div class="es-prog-tags fs-14 font-lato">
																			<span class="fw-400 color-72738e">
																				Total Duration:</span
																			><span class="fw-600 color-mainblue">
																				{{
																					formatDuration(
																						selectedCommunicationSEction.totalDurationInSec
																					)
																				}}</span
																			>
																		</div>
																		<div class="es-prog-tags fs-14 font-lato">
																			<span class="fw-400 color-72738e">
																				Avg WPM:</span
																			><span class="fw-600 color-mainblue">
																				{{
																					selectedCommunicationSEction.avgWpm
																				}}</span
																			>
																		</div>
																	</section>

																	<section
																		class="color-mainblue fs-14 fw-600 font-mont"
																		v-b-toggle.communicationdetails
																	>
																		{{
																			communicationDetailsOpen
																				? "Hide Detailed Summary"
																				: "Show Detailed Summary"
																		}}
																		<img
																			src="@/assets/newimgs/circulararw.svg"
																			alt=""
																			class="ml-2 rotate-arrow"
																			:class="{
																				rotated: !communicationDetailsOpen,
																			}"
																		/>
																	</section>
																</section>

																<b-collapse
																	id="communicationdetails"
																	v-model="communicationDetailsOpen"
																>
																	<template v-if="communicationBreakdown">
																		<div
																			v-for="(item,
																			index) in communicationBreakdown"
																			:key="index"
																			class="es-collapsed-cards d-flex mt-3 position-relative align-items-center"
																		>
																			<!-- Label -->
																			<div
																				style="    width: 115px;"
																				class="fw-600 fs-14 font-mont color-464667 mt-1"
																			>
																				{{ item.label }}:
																			</div>

																			<!-- Score -->
																			<div
																				class="es-green-tag-collapse ml-2 fs-14 fw-600 d-flex align-items-center justify-content-center"
																				:class="`color-${item.color}-progress`"
																			>
																				{{ item.score }} / {{ item.outOf }}
																			</div>

																			<!-- Divider Line -->
																			<div
																				class="my-3 grey-dotted-hr es-vertical-line"
																				style="    top: -11px;height: 85%;left: 240px"
																			></div>

																			<!-- Feedback text -->
																			<div
																				class="fw-400 fs-14 font-lato ml-4 color-464667 w-85"
																			>
																				{{ item.feedback }}
																			</div>
																		</div>
																	</template>
																</b-collapse>
															</section>
															<div
																class="grey-dotted-hr"
																style="margin:30px 0"
															></div>
															<section class="">
																<div
																	class="es-ct-quescard mt-3"
																	v-for="(question,
																	quesIndex) in selectedCommunicationSEction.sectionResponse"
																	:key="quesIndex"
																	:ref="`commQuesCard_${secIndex}_${quesIndex}`"
																>
																	<section
																		@click="
																			toggleCommCollapse(
																				secIndex,
																				question.answerStatus.attempted,
																				quesIndex
																			)
																		"
																		style="padding: 24px"
																		class="d-flex align-items-center justify-content-between pointer"
																	>
																		<div
																			class="font-lato fs-16 color-464667 d-flex align-items-center"
																		>
																			<div class="fw-600">
																				Question {{ quesIndex + 1 }} — &nbsp;
																			</div>
																			<div
																				class="fw-400"
																				v-html="question.questionBody.question"
																			></div>
																		</div>

																		<div
																			class="d-flex align-items-center gap-2"
																		>
																			<div
																				class="es-green-tag-collapse px-5"
																				style="width: fit-content;"
																				:class="getQuestionBadgeClass(question)"
																			>
																				{{
																					question.extraQuestion
																						? "Extra Question"
																						: !question.answerStatus ||
																						  !question.answerStatus.attempted
																						? "Not Answered"
																						: question.questionMarks +
																						  "/" +
																						  question.questionBody.marks
																				}}
																			</div>

																			<img
																				v-if="question.answerStatus.attempted"
																				src="@/assets/newimgs/circulararw.svg"
																				alt=""
																				class="ml-2 rotate-arrow pointer"
																				:class="{
																					rotated:
																						openCollapseCommunicationQuestion[
																							secIndex
																						] !== quesIndex,
																				}"
																			/>
																		</div>
																	</section>
																	<b-collapse
																		:id="'commuQuescollapse-' + quesIndex"
																		:visible="
																			openCollapseCommunicationQuestion[
																				secIndex
																			] === quesIndex
																		"
																	>
																		<div class="grey-dotted-hr mb-3"></div>
																		<section
																			style="padding: 0 24px 0 24px;"
																			class="color-333333 fw-600 fs-16 font-lato"
																		>
																			<img
																				src="../../assets/newimgs/candanswericon.svg"
																				class="mr-2"
																				alt=""
																			/>
																			Candidate Answer
																		</section>

																		<section
																			class="candidate-audio d-flex align-items-center gap-3 mt-2"
																			style="padding: 0 24px 0 24px;"
																		>
																			<!--  If audio is NOT available -->
																			<template
																				v-if="!question.answer.audioPath"
																			>
																				<div class="no-audio-text">
																					Audio not available
																				</div>
																			</template>

																			<!-- If audio exists -->
																			<template v-else>
																				<div
																					class="play-btn pointer"
																					@click="
																						toggleAudio2(secIndex, quesIndex)
																					"
																				>
																					<img
																						:src="
																							isPlayingMap[
																								secIndex + '_' + quesIndex
																							]
																								? require('@/assets/newimgs/playerpause.svg')
																								: require('@/assets/newimgs/playbtn.svg')
																						"
																					/>
																				</div>

																				<div class="flex-grow-1">
																					<div
																						class="audio-progress"
																						@click="
																							seekAudio(
																								$event,
																								secIndex,
																								quesIndex
																							)
																						"
																					>
																						<div
																							class="audio-progress-fill"
																							:style="{
																								width:
																									durationMap[
																										secIndex + '_' + quesIndex
																									] > 0
																										? Math.min(
																												(currentTimeMap[
																													secIndex +
																														'_' +
																														quesIndex
																												] /
																													durationMap[
																														secIndex +
																															'_' +
																															quesIndex
																													]) *
																													100,
																												100
																										  ) + '%'
																										: '0%',
																							}"
																						></div>
																					</div>
																				</div>

																				<div class="time-label">
																					{{
																						formattedTime(secIndex, quesIndex)
																					}}
																				</div>

																				<audio
																					:ref="
																						'audioRef2_' +
																							secIndex +
																							'_' +
																							quesIndex
																					"
																					:src="question.answer.audioPath"
																					@loadedmetadata="
																						onAudioLoaded(secIndex, quesIndex)
																					"
																					@timeupdate="
																						updateTimeline(secIndex, quesIndex)
																					"
																					@play="
																						isPlayingMap[
																							secIndex + '_' + quesIndex
																						] = true
																					"
																					@pause="
																						isPlayingMap[
																							secIndex + '_' + quesIndex
																						] = false
																					"
																					playsinline
																				></audio>
																			</template>
																		</section>
																		<section
																			class="es-aisummary-container"
																			style="margin: 15px 24px 0 24px;"
																			v-if="
																				question.additionalInfo &&
																					question.additionalInfo
																						.finalScoreFeedback
																			"
																		>
																			<div
																				class="d-flex align-items-center color-mainblue fw-600 fs-14 font-mont"
																			>
																				<img
																					src="../../assets/bluesparkle.svg"
																					class="mr-2"
																					alt=""
																				/>
																				AI Summary
																			</div>

																			<div class="ai-summary-container mt-2">
																				<p
																					class="ai-summary-text color-464667 fs-16 fw-400 font-lato"
																					:class="{
																						expanded: showFullAISummary[index],
																					}"
																					
																				>
																					{{
																						question.additionalInfo
																							.finalScoreFeedback
																					}}
																				</p>

																				<span
																					v-if="
																						shouldShowReadMore(
																							question.additionalInfo
																								.finalScoreFeedback
																						)
																					"
																					class="ai-read-more fs-16 fw-700 color-mainblue pointer"
																					@click="toggleAISummary(index)"
																				>
																					{{
																						showFullAISummary[index]
																							? "Read less"
																							: "Read more"
																					}}
																				</span>
																			</div>
																		</section>

																		<section
																			class="es-ct-transcriptcard mt-3"
																			v-if="question.additionalInfo"
																			style="margin: 0 24px 0 24px;"
																		>
																			<div
																				class="color-464667 fs-14 fw-600 font-mont mb-2"
																			>
																				Transcript
																			</div>
																			<div
																				class="fw-400 font-lato fs-16 color-464667"
																				v-html="formattedSentence(question)"
																			></div>
																		</section>
																		<hr />

																		<section
																			class="d-flex flex-wrap align-items-center gap-3"
																			v-if="question.additionalInfo"
																			style="padding: 0 24px 24px 24px;"
																		>
																			<div
																				class="es-prog-tags fs-14 font-lato d-flex align-items-center"
																			>
																				<img
																					src="../../assets/pause-icon.svg"
																					alt=""
																				/>
																				<span
																					class="fw-400 color-72738e ml-2"
																					style="    margin-top: -1px;"
																					>Bad Pause:</span
																				>
																				<span
																					class="fw-600 color-mainblue ml-1"
																					style="margin-top: -1px;"
																				>
																					{{
																						question.additionalInfo.pauseCount
																					}}
																				</span>
																			</div>
																			<div class="es-prog-tags fs-14 font-lato">
																				<span class="fw-400 color-72738e"
																					>Pronunciation:</span
																				>
																				<span
																					class="fw-600"
																					:class="
																						getScoreColor(
																							question.additionalInfo
																								.pronunciationScore
																						)
																					"
																				>
																					&nbsp;{{
																						question.additionalInfo
																							.pronunciationScore
																					}}
																					/ 2.0
																				</span>
																			</div>

																			<div class="es-prog-tags fs-14 font-lato">
																				<span class="fw-400 color-72738e"
																					>Grammar:</span
																				>
																				<span
																					class="fw-600"
																					:class="
																						getScoreColor(
																							question.additionalInfo
																								.grammarScore
																						)
																					"
																				>
																					&nbsp;{{
																						question.additionalInfo.grammarScore
																					}}
																					/ 2.0
																				</span>
																			</div>

																			<div class="es-prog-tags fs-14 font-lato">
																				<span class="fw-400 color-72738e"
																					>Fluency:</span
																				>
																				<span
																					class="fw-600"
																					:class="
																						getScoreColor(
																							question.additionalInfo
																								.fluencyScore
																						)
																					"
																				>
																					&nbsp;{{
																						question.additionalInfo.fluencyScore
																					}}
																					/ 2.0
																				</span>
																			</div>

																			<div class="es-prog-tags fs-14 font-lato">
																				<span class="fw-400 color-72738e"
																					>Vocabulary:</span
																				>
																				<span
																					class="fw-600"
																					:class="
																						getScoreColor(
																							question.additionalInfo
																								.vocabularyScore
																						)
																					"
																				>
																					&nbsp;{{
																						question.additionalInfo
																							.vocabularyScore
																					}}
																					/ 2.0
																				</span>
																			</div>

																			<div class="es-prog-tags fs-14 font-lato">
																				<span class="fw-400 color-72738e"
																					>Relevance to Topic:</span
																				>
																				<span
																					class="fw-600"
																					:class="
																						getScoreColor(
																							question.additionalInfo
																								.relatableScore
																						)
																					"
																				>
																					&nbsp;{{
																						question.additionalInfo
																							.relatableScore
																					}}
																					/ 2.0
																				</span>
																			</div>
																		</section>
																	</b-collapse>
																</div>
															</section>
														</div>
													</b-tab>
												</b-tabs>
											</div>
										</b-tab>
									</b-tabs>
									<div
										class="es-footer-section d-flex justify-content-between align-items-center"
										v-if="selectedAttempt.isSubmitted"
									>
										<div class="d-flex align-items-center position-relative">
											<!-- <div class="font-mont fw-400 fs-14 color-6D6D6D">
															<img
																src="../../assets/non-evaluated.svg"
																alt=""
															/>
															Non Evaluated
														</div> -->
											<div class="ml-2 font-mont fw-400 fs-14 color-6D6D6D">
												<img src="../../assets/evaluated.svg" alt="" />
												Evaluated
											</div>
											<div class="ml-2 font-mont fw-400 fs-14 color-6D6D6D">
												<img src="../../assets/non-Attempted.svg" alt="" />
												Non Attempted
											</div>
											<div class="ml-2 font-mont fw-400 fs-14 color-6D6D6D">
												<img src="../../assets/attempted.svg" alt="" />
												Attempted
											</div>
										</div>
										<div
											id="evaluate-btn"
											@click="!isEvaluateDisabled && evaluateTest()"
											v-b-popover.hover.top="
												isEvaluateDisabled
													? 'Communication test result pending!'
													: ''
											"
											:class="[
												'es-viewmark-btn',
												'text-center',
												'color-white',
												'fw-600',
												'fs-13',
												'font-mont',
												'pointer',
												{ 'disabled-btn': isEvaluateDisabled },
											]"
											v-if="selectedAttempt.markingCheck"
										>
											{{
												selectedAttempt.evaluation ? "Re-Evaluate" : "Evaluate"
											}}
										</div>
									</div>
								</div>
							</section>
						<section
							v-if="selectedAttempt.sandboxResults === 'pending'"
							id="section-5"
							class="position-sticky top-0 z-1 py-3 es-last-section-tabs"
							style="height: calc(100vh - 70px); background: #e8ebee; top: 70px;"
						>
							<section
								class="d-flex align-items-center w-100 justify-content-between mt-3 mb-3"
							>
								<h5 class="fw-600 fs-16 font-poppins color-464667">
									Sandbox Evaluation
								</h5>
								<div class="d-flex align-items-center gap-3 eval-btns mr-2">
									<b-button @click="vewSandboxCode()">
										<img
											class="mr-2"
											src="../../assets/projects-icons/evaluate-screen/view-sb.svg"
											alt=""
										/>
										View Code Sandbox
									</b-button>
								</div>
							</section>
							<div
								class="d-flex flex-column align-items-center justify-content-center gap-3"
								style="background: #fff; border-radius: 8px; height: calc(100vh - 200px);"
							>
								<img
									src="../../assets/sandbox-evaluation-pending.svg"
									alt="Evaluation Pending"
									style="width: 80px; height: 80px;"
								/>
								<p class="mb-0 fw-500 fs-14 font-mont color-72738e font-italic">
									Please wait while the sandbox results are being calculated
								</p>
							</div>
						</section>
						<section
							v-else-if="
								selectedAttempt.sandboxResults &&
									Object.keys(selectedAttempt.sandboxResults).length > 0
							"
							id="section-5"
							class="position-sticky top-0 z-1 py-3 es-last-section-tabs"
							style="	height: calc(100vh - 70px);background:#e8ebee ;top: 70px;"
						>
								<section
									class="d-flex align-items-center w-100 justify-content-between mt-3 mb-3"
								>
									<h5 class="fw-600 fs-16 font-poppins color-464667">
										Sandbox Evaluation
									</h5>
									<div class="d-flex align-items-center gap-3 eval-btns">
										<div
											v-if="
												selectedAttempt.markingCheck ||
													selectedAttempt.evaluation
											"
										>
											<b-button v-if="!giveMarks" @click="giveMarks = true">
												<img
													class="mr-2"
													src="../../assets/projects-icons/evaluate-screen/givemarks-sb.svg"
													alt=""
												/>
												{{
													selectedAttempt.markingCheck &&
													!selectedAttempt.evaluation
														? "Give Marks"
														: "View Marks"
												}}
											</b-button>
											<div
												v-else
												class="d-flex gap-3 align-content-center position-relative"
											>
												<b-form-input
													:disabled="!selectedAttempt.markingCheck"
													v-model="sandboxMarks"
													:class="invalidSandboxMarks ? 'error' : ''"
													placeholder="Enter Marks"
													class="evaluate-sandbox-input"
													@wheel.prevent
												/>
												<div class="out-off-marks-eval">
													/ {{ selectedAttempt.totalTestMarks }}
												</div>
												<template>
													<img
														@click="giveMarks = false"
														class="pointer"
														src="../../assets/projects-icons/undoMarks.svg"
														alt=""
													/>
													<img
														v-if="selectedAttempt.markingCheck"
														@click="evaluateTest(true)"
														class="pointer"
														src="../../assets/projects-icons/saveMarks.svg"
														alt=""
													/>
												</template>
											</div>
										</div>
										<div class="eval-btns mr-2">
											<b-button @click="vewSandboxCode()">
												<img
													class="mr-2"
													src="../../assets/projects-icons/evaluate-screen/view-sb.svg"
													alt=""
												/>
												View Code Sandbox
											</b-button>
										</div>
									</div>
								</section>
								<section
									class="overflow-auto pr-1"
									style="height: calc(100vh - 145px);background: rgb(232, 235, 238);"
								>
									<section class="es-section-5">
										<h6 class="fs-16 fw-500 font-lato color-black padding1324">
											SonarQube
										</h6>
										<hr class="mx-1 mt-0" />
										<div class="es-section-5-cards-container gap-3 padding2024">
											<div
												v-for="metric in selectedAttempt.sandboxResults
													.SONARQUBE"
												:key="metric.metric"
												class="es-section-5-cards d-flex flex-column align-items-center justify-content-center gap-3"
											>
												<h6 class="mb-0 font-mont fs-16 color-333333 fw-500">
													{{ metric.label }}
												</h6>
												<h4 class="mb-0 fw-600 fs-22 font-mont color-72738e">
													{{ metric.value }}
												</h4>
												<p
													class="my-0 fw-500 fs-13 font-mont color-72738e text-center"
												>
													{{ metric.description }}
												</p>
											</div>
										</div>
									</section>
									<section class="d-flex align-items-center gap-3 mt-3">
										<div
											class="sanboxtriggerbox w-50"
											v-if="'DB_TRIGGER' in selectedAttempt.sandboxResults"
										>
											<h6
												class="fs-16 fw-500 font-lato color-black padding1324"
											>
												DB Trigger
											</h6>
											<hr class="mx-1 mt-0" />
											<div
												class="padding2024 fw-500 fs-16 font-mont color-72738e d-flex align-items-center gap-1"
											>
												<img
												 	v-if="selectedAttempt.sandboxResults.DB_TRIGGER"
													src="../../assets/newimgs/sandboxtick.svg"
													alt=""
												/>
												<img
													v-else
													src="../../assets/newimgs/sandboxcross.svg"
													alt=""
												/>
												{{ selectedAttempt.sandboxResults.DB_TRIGGER }}
											</div>
										</div>
										<div
											class="sanboxtriggerbox w-50"
											v-if="
												selectedAttempt.sandboxResults.DB_TRIGGER ||
													buildAndRunDetails
											"
										>
											<h6
												class="fs-16 fw-500 font-lato color-black padding1324"
											>
												{{ buildAndRunDetails.label }}
											</h6>
											<hr class="mx-1 mt-0" />
											<div
												class="padding2024 fw-500 fs-16 font-mont color-72738e d-flex align-items-center gap-1"
											>
												<img
													:src="
														buildAndRunDetails.value
															? require('../../assets/newimgs/sandboxtick.svg')
															: require('../../assets/newimgs/sandboxcross.svg')
													"
													alt=""
												/>
												{{ buildAndRunDetails.value }}
											</div>
										</div>
									</section>
								</section>
							</section>
						</b-tab>
					</b-tabs>
				</b-card>
			</section>
		</section>
		<b-modal
			id="viewmarksmodal"
			centered
			hide-footer
			hide-header
			size="md"
			class="viewdetailsmodal"
			v-if="showViewMarksModal"
			v-model="showViewMarksModal"
			@hidden="showViewMarksModal = false"
		>
			<section class="d-flex align-items-center justify-content-between p-3">
				<div class="font-lato color-black fw-500 fs-18">
					Attempt {{ selectedAttempt.attemptNo }} details
				</div>
				<div @click="showViewMarksModal = false" class="pointer">
					<img src="../../assets/newimgs/x-close.svg" alt="" />
				</div>
			</section>
			<hr class="my-0" />
			<section class="p-3">
				<div
					class="viewmarks-namebox d-flex justify-content-between align-items-center"
				>
					<div class="color-696969 fs-13 fw-500 font-mont">
						Name
					</div>
					<div class="color-696969 fs-14 fw-600 font-mont">
						{{ selectedAttempt.name }}
					</div>
				</div>
				<div class="mt-3 viewmarks-body-part">
					<section class="d-flex align-items-center justify-content-between">
						<div>
							<h6 class="fw-500 fs-13 color-6D6D6D font-mont">Test Name</h6>
							<h5 class="color-696969 fs-14 fw-600 font-mont">
								{{ overallResult.testName }}
							</h5>
						</div>
						<div>
							<h6 class="fw-500 fs-13 color-6D6D6D font-mont">
								Date :
								<span class="fw-600 color-696969">{{
									formatDate(selectedAttempt.stats.timing.endTime)
								}}</span>
							</h6>
							<h6 class="fw-500 fs-13 color-6D6D6D font-mont">
								Result :
								<span
									class="fw-600"
									:class="
										selectedAttempt.status == 'Pass'
											? 'color-green'
											: 'color-red'
									"
									>{{ selectedAttempt.status }}</span
								>
							</h6>
						</div>
					</section>
					<div class="grey-dotted-hr my-2"></div>
					<section class="mt-3">
						<div class="d-flex align-items-center justify-content-between">
							<h6 class="fw-500 fs-13 color-6D6D6D font-mont">
								<img
									src="../../assets/icons/proctoring/result.svg"
									class="mr-1"
									alt=""
								/>
								Marks
							</h6>
							<h6 class="fw-500 fs-13 color-6D6D6D font-mont">
								Total Marks
								<span class="fw-600 color-696969"
									>{{ selectedAttempt.marks }}/{{
										selectedAttempt.totalTestMarks
									}}</span
								>
							</h6>
						</div>
						<div
							v-for="(secdetail, index) in selectedAttempt.testResponse"
							:key="index"
							class="mt-2 viewmarks-markbox d-flex align-items-center justify-content-between"
						>
							<h6 class="mb-0 fw-400 fs-13 color-696969 font-mont">
								{{ secdetail.sectionName }}
							</h6>
							<h5 class="mb-0 fw-600 fs-14 color-green font-mont">
								{{ secdetail.sectionMarks }}/{{ secdetail.serctionTotalMarks }}
							</h5>
						</div>
					</section>
				</div>
				<section class="mt-3 viewmarks-body-part">
					<h6 class="font-mont color-6D6D6D fs-13 fw-500 mb-1">Address</h6>
					<div class="grey-dotted-hr my-2"></div>
					<div class="d-flex align-items-center mt-3">
						<img src="../../assets/newimgs/address.svg" alt="" />
						<h6 class="mb-0 fw-500 font-mont fs-14 color-696969 ml-2">
							{{
								checkForGeolocation()
									? selectedAttempt.stats.geolocation.address.formatted_address
									: "--"
							}}
						</h6>
					</div>
				</section>
			</section>
		</b-modal>
		<b-modal
			id="showcodingquestionanswer"
			centered
			hide-footer
			hide-header
			size="xl"
			class="viewdetailsmodal"
			v-if="showCodingAnswerModal"
			v-model="showCodingAnswerModal"
			@hidden="showCodingAnswerModal = false"
		>
			<section class="d-flex align-items-center justify-content-between p-3">
				<div class="font-lato color-black fw-500 fs-18">
					View Answer
				</div>
				<div @click="showCodingAnswerModal = false" class="pointer">
					<img src="../../assets/newimgs/x-close.svg" alt="" />
				</div>
			</section>
			<hr class="my-0" />
			<section
				class="p-3 d-flex gap-3 w-100 overflow-auto"
				style="height: calc(100vh - 195px);"
				v-if="selectedCodingQuestion.questionBody"
			>
				<section class="w-50">
					<div class="es-coding-left-container">
						<div>
							<div class="d-flex align-items-center gap-3">
								<span
									class="es-coding-smalltabs font-lato fs-11 fw-500 color-72738e"
									>{{ selectedCodingQuestion.questionBody.marks }} Mark</span
								>
								<span
									class="es-coding-smalltabs font-lato fs-11 fw-500 color-72738e"
									>Difficulty Level -
									{{
										selectedCodingQuestion.questionBody.difficultyLevel
									}}</span
								>
							</div>
							<div
								class="es-coding-smalltabs font-lato fs-11 fw-500 color-72738e mt-3"
							>
								Category- {{ selectedCodingQuestion.questionBody.category }}
							</div>
						</div>
						<h5 class="fs-14 fw-600 font-mont color-3a3c40 mt-3">
							Q1.{{ selectedCodingQuestion.questionBody.title }}
						</h5>
						<h6
							class="fs-14 fw-400 font-mont color-3a3c40 lh-21"
							v-html-safe="selectedCodingQuestion.questionBody.question"
						></h6>
						<hr />
						<section class="es-coding-contraints">
							<h6 class="fs-12 fw-500 font-lato color-3a3c40">Constraints</h6>
							<ul>
								<li
									class="fs-14 fw-600 font-mont color-3a3c40"
									v-html-safe="selectedCodingQuestion.questionBody.constraints"
								>
									<!-- 1 <= nums.length <= 105 -->
								</li>
								<!-- <li class="fs-14 fw-600 font-mont color-3a3c40">
									 0 <= nums[i] <= 105
								</li> -->
							</ul>
						</section>
						<hr />
						<section class="sampleinputoutput">
							<h6 class="fs-12 fw-500 font-lato color-3a3c40">Sample</h6>
							<ul>
								<li class="fs-14 fw-600 font-mont color-3a3c40 d-flex">
									Input:<span
										class="ml-1"
										v-html-safe="
											selectedCodingQuestion.questionBody.sampleInput
										"
									></span>
								</li>
								<li class="fs-14 fw-600 font-mont color-3a3c40 d-flex">
									Output:
									<span
										class="ml-1"
										v-html-safe="
											selectedCodingQuestion.questionBody.sampleOutput
										"
									></span>
								</li>
							</ul>
						</section>
						<section class="es-coding-testcase-container">
							<h5 class="color-3a3c40 fs-14 fw-600 font-mont">Test Cases</h5>
							<!-- <h6
								class="fs-12 fw-500 color-7a7a7a font-mont d-flex align-items-center"
							>
								<img
									src="../../assets/newimgs/blueinfo.svg"
									class="mr-1"
									alt=""
								/>
								These are all visible test cases
							</h6> -->
							<div class="d-flex gap-3">
								<div class="es-coding-dd">
									<div
										v-for="(item, index) in visibletc"
										:key="index"
										@click="selectTc(item)"
										:class="
											selectedTestCase == item
												? 'selected fw-700 fs-14 color-3a3c40'
												: ''
										"
										class="item d-flex align-items-center font-lato fs-12 fw-400 color-7a7a7a pointer"
									>
										Test Case {{ index + 1 }}

										<img
											v-if="!item.visible"
											src="../../assets/newimgs/lock.svg"
											alt=""
											class="ml-1"
										/>
									</div>
								</div>
								<div class="w-70">
									<div class="p10px es-coding-left-container w-100">
										<h5 class="fs-12 fw-600 font-mont color-3a3c40">Input</h5>
										<p class="pl-2 fs-12 fw-400 font-lato color-7a7a7a">
											{{ selectedTestCase.inputValue }}
										</p>
									</div>
									<div class="p10px es-coding-left-container w-100 mt-3">
										<h5 class="fs-12 fw-600 font-mont color-3a3c40">
											Output
										</h5>
										<p class="pl-2 fs-12 fw-400 font-lato color-7a7a7a">
											{{ selectedTestCase.outputValue }}
										</p>
									</div>
								</div>
							</div>
						</section>
					</div>
				</section>
				<section class="w-50">
					<div class="d-flex justify-content-between align-items-center">
						<h6 class="fs-14 fw-600 font-mont color-3a3c40 mb-0">
							Candidate Answer
						</h6>
						<div class="fs-14 fw-500 font-mont color-3a3c40 lang-selected">
							Selected Language | {{ codeData.languagename }}
						</div>
					</div>
					<!-- <h6 class="fs-14 fw-600 font-mont color-3a3c40">Candidate Answer</h6> -->
					<div
						style="background-color: black;"
						class="mt-3 es-coding-editor editorContainer"
						id="editorContainer"
					></div>
					<div class="w-100 d-flex justify-content-end mt-3">
						<div
							style="width: 140px;"
							@click="runCodeForCompilation(selectedCodingQuestion)"
							class="es-viewmark-btn text-center color-white fw-600 fs-13 font-mont pointer"
						>
							<span v-if="!isCompiling">Run Code</span>
							<span
								v-else
								class="spinner-border spinner-border-sm text-light"
								role="status"
							></span>
						</div>
					</div>
					<hr />
					<h6 class="fs-14 fw-600 font-mont color-3a3c40" v-if="testCaseResult">
						Test Result
					</h6>
					<section
						class="mt-2 es-coding-testresult-container"
						ref="scrollContainer"
						v-if="testCaseResult"
					>
						<div
							v-if="compiledTestCasesResult.totalTestCasesFailed > 0"
							class="d-flex align-items-center color-white fs-13 fw-500 font-mont"
							:class="
								compiledTestCasesResult.totalTestCasesFailed > 0
									? 'es-coding-red-header'
									: 'es-coding-green-header'
							"
						>
							{{
								compiledTestCasesResult.totalTestCasesFailed > 0
									? `Compilation Failed - ${compiledTestCasesResult.totalTestCasesPasses} /
											${compiledTestCasesResult.totalTestCases} test cases are passed`
									: "Test Completed Successfully - All test cases are passed"
							}}
						</div>
						<section v-if="selectedCase.data != null">
							<h6 class="mt-3 fs-13 fw-500 font-mont color-333333">
								Compile Message
							</h6>
							<div class="p10px es-coding-left-container w-100 mt-2 wordbreak">
								<p class="fs-14 fw-500 font-mont color-7a7a7a">
									{{ selectedCase.data }}
								</p>
							</div>
						</section>
						<hr />
						<div class="d-flex gap-3">
							<div class="es-coding-right-testcase-dd">
								<div
									v-for="(testCase,
									index) in compiledTestCasesResult.testCaseResult"
									:key="index"
									@click="selectRunningTc(testCase)"
									:class="[
										'fw-700 fs-14',
										selectedCase === testCase && testCase.resultCode
											? 'selected color-green'
											: '',
										selectedCase === testCase && !testCase.resultCode
											? 'selected color-3a3c40'
											: '',
										testCase.resultCode ? 'color-green' : 'color-3a3c40',
									]"
									class="item d-flex align-items-center justify-content-between font-lato fs-12 fw-400 pointer"
								>
									<div>
										<img
											v-if="testCase.resultCode"
											src="../../assets/newimgs/greentick.svg"
											class="mr-1"
											alt=""
										/>
										<img
											v-else
											src="../../assets/newimgs/red-cross.svg"
											class="mr-1"
											alt=""
										/>
										Test Case {{ index + 1 }}
									</div>
									<div>
										<img
											v-if="!testCase.visible"
											src="../../assets/newimgs/lock.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
							<div class="w-65">
								<div class="p10px es-coding-left-container w-100">
									<h5 class="fs-12 fw-600 font-mont color-3a3c40">Input</h5>
									<p class="pl-2 fs-12 fw-400 font-lato color-7a7a7a">
										{{ selectedCase.inputValue }}
									</p>
								</div>
								<div class="p10px es-coding-left-container w-100 mt-3">
									<h5 class="fs-12 fw-600 font-mont color-3a3c40">
										Expected Output
									</h5>
									<p class="pl-2 fs-12 fw-400 font-lato color-7a7a7a">
										{{ selectedCase.outputValue }}
									</p>
								</div>
								<div class="p10px es-coding-left-container w-100 mt-3">
									<h5 class="fs-12 fw-600 font-mont color-3a3c40">
										Actual Output
									</h5>
									<p class="pl-2 fs-12 fw-400 font-lato color-7a7a7a">
										{{ selectedCase.data }}
									</p>
								</div>
							</div>
						</div>
					</section>
				</section>
			</section>
			<hr class="my-0" />
			<div
				class="d-flex justify-content-end align-items-center w-100 gap-3 p-3"
			>
				<div
					class="topDiv position-realtive d-flex align-items-center givemark vcps"
				>
					<label
						class="fieldsetStyle fw-400 fs-9 font-poppins color-696969"
						style="z-index: 8"
						>Give Marks &nbsp;<span class="asterik">*</span></label
					>
					<b-form-input
						:disabled="!selectedAttempt.markingCheck"
						class="vcp-inputField no-spinner"
						type="number"
						placeholder="Enter"
						:class="
							invalidMarks[
								`${codeSection.sectionID}_${selectedCodingQuestion.questionKey}`
							]
								? 'error'
								: ''
						"
						@input="updateMarks(selectedCodingQuestion, $event, codeSection)"
						v-model="selectedCodingQuestion.questionMarks"
						@wheel.prevent
					></b-form-input>
					<div
						v-if="
							invalidMarks[
								`${codeSection.sectionID}_${selectedCodingQuestion.questionKey}`
							]
						"
						class="es-eval-validationicon"
						variant="primary"
						v-b-popover.hover.v-danger="{
							content: invalidMarks[
								`${codeSection.sectionID}_${selectedCodingQuestion.questionKey}`
							]
								? invalidMarks[
										`${codeSection.sectionID}_${selectedCodingQuestion.questionKey}`
								  ].reason
								: '',
						}"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					/<span>{{
						selectedCodingQuestion.questionBody
							? selectedCodingQuestion.questionBody.marks
							: 0
					}}</span>
				</div>
				<!-- givemark-btn-disable -- bind this class for disabled for below div   -->
				<div
					v-if="selectedAttempt.markingCheck"
					style="width: 140px;"
					@click="evaluateTest(false, true)"
					class="es-viewmark-btn text-center color-white fw-600 fs-13 font-mont pointer"
				>
					Give Mark
				</div>
			</div>
		</b-modal>
	</main>
</template>

<script>
import pauseIcon from "@/assets/pause-icon.svg";
import {
	evaluateAnswers,
	getproctoringCandidatesv3,
	testCaseRunner,
	getProctoringData,
} from "@/utils/apiFunctions";
import toast from "../mixin/toast";
import { ProctorGraph } from "./proctorGraph";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import VideoPlayer from "./VideoPlayer.vue";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

export default {
	data() {
		return {
			hasVideoStartedMap: {},
			isVideoSeekingMap: {},
			codeSection: {},
			isCompiling: false,
			graphGeneartion: false,
			openCollapseCommunicationQuestion: {},
			hasPlayed: {},
			communicationDetailsOpen: false,
			isPlayingMap: {},
			durationMap: {},
			currentTimeMap: {},
			currentCommVideoPath: null,
			isMiniMap: {},
			isAnimatingMap: {},
			videoDuration: 0,
			marker1: null,
			marker2: null,
			tooglePlay: false,
			agentTimeStamps: [],
			extensionTimeStamps: [],
			logData: [],
			showLogs: false,
			videoProctoringData: null,
			proctoringData: null,
			allProctorData: null,
			n: 0,
			showAnswer: null,
			selectedSection: {},
			invalidMarks: {},
			allQuestions: [],
			audio: null,
			isPlaying: false,
			audioDuration: 0,
			currentBar: 0,
			waveformData: [], // Simulated waveform heights
			intervalId: null,
			overallResult: {},
			codingquestions: [],
			communicationQuestions: [],
			codingsection: false,
			selectedCodingQuestion: {},
			selectedCodeSection: {},
			selectedCommunicationSEction: {},
			selectedTestCase: {},
			visibletc: [],
			tabIndex: 0,
			selectedAttempt: {
				testResponse: [],
				stats: {},
				remarks: [],
				video: {
					camera: "",
				},
			},
			attempts: 10,
			activeSection: 1,
			scrollContainer: null,
			observer: null,
			codeData: [],
			activeForTopic: {},
			topicCardselected: null,
			compiledTestCasesResult: {},
			selectedCase: {},
			testCaseResult: false,
			showViewMarksModal: false,
			showCodingAnswerModal: false,
			activeTab: 1,
			totalSections: 4,
			sandboxMarks: null,
			invalidSandboxMarks: false,
			giveMarks: false,
			showShimmer: false,
			seconds: null,
			proctoringEvents: ["Head", "Mouth", "Cheating", "Eye"],
			showFullAISummary: {},
		};
	},
	components: { Spinner, VideoPlayer },
	mounted() {
		this.$nextTick(this.checkAISummaryOverflow);
		this.$nextTick(() => {
			const container = this.$refs.mainScrollContainer;
			if (container) {
				this.observeSections(); // Start observing
			}
		});

		this.waveformData = Array.from({ length: 100 }, () =>
			Math.floor(Math.random() * 10 + 6)
		);
		document.addEventListener("keydown", (e) => {
			if (e.code == "Space") {
				e.preventDefault();
			}
		});
	},
	mixins: [toast],
	async created() {
		// this.LoaderStatus = true;
		await this.getProctoringData(this.$route.query.attemptNo || 1);
		if (this.$route.query.attemptNo) {
			await this.getProctorDetails(this.$route.query.attemptNo);
			this.tabIndex = parseInt(this.$route.query.attemptNo - 1);
		} else {
			await this.getProctorDetails(1);
		}
		setTimeout(() => {
			this.getProctorGraph();
		}, 2000);
	},
	watch: {
		communicationQuestions: {
			immediate: false,
			handler(newVal) {
				if (!newVal || !newVal.length) return;
				this.initFloatingVideo();
			},
		},
	},
	beforeDestroy() {
		if (this.observer) {
			this.observer.disconnect();
		}
	},
	computed: {
		communicationBreakdown() {
			const s = this.selectedCommunicationSEction;
			const score = s.overallCommunicationSectionScore || {};
			const fb = s.overallFeedbacks || {};

			// Helper to extract feedback safely
			const getFeedback = (item) => {
				const val = fb[item];

				// If it's a string → return string or fallback
				if (typeof val === "string") {
					return val || "No feedback provided.";
				}

				// If it's an object → return commonPatterns or fallback
				return val?.commonPatterns || "No feedback provided.";
			};

			return [
				{
					label: "Pronunciation",
					score: score.pronunciationScore?.score ?? 0,
					feedback: getFeedback("overallPronunciationFeedback"),
					outOf: score.outOf ?? 2,
					color: score.pronunciationScore?.color ?? "gray",
				},
				{
					label: "Fluency",
					score: score.fluencyScore?.score ?? 0,
					feedback: getFeedback("overallFluencyFeedback"),
					outOf: score.outOf ?? 2,
					color: score.fluencyScore?.color ?? "gray",
				},
				{
					label: "Vocabulary",
					score: score.vocabularyScore?.score ?? 0,
					feedback: getFeedback("overallVocabularyFeedback"),
					outOf: score.outOf ?? 2,
					color: score.vocabularyScore?.color ?? "gray",
				},
				{
					label: "Grammar",
					score: score.grammarScore?.score ?? 0,
					feedback: getFeedback("overallGrammarFeedback"),
					outOf: score.outOf ?? 2,
					color: score.grammarScore?.color ?? "gray",
				},
			];
		},

		isEvaluateDisabled() {
			return this.communicationQuestions?.some(
				(section) => section.comuSectionEvaluated === false
			);
		},
		buildAndRunDetails() {
			if ("BUILD" in this.selectedAttempt.sandboxResults) {
				return {
					label: "Build",
					value: this.selectedAttempt.sandboxResults.BUILD,
				};
			} else if ("RUN" in this.selectedAttempt.sandboxResults) {
				return {
					label: "Run",
					value: this.selectedAttempt.sandboxResults.RUN,
				};
			} else return null;
		},
	},
	methods: {
		onVideoSeeking(secIndex) {
			// mark that this pause is due to seeking
			this.$set(this.isVideoSeekingMap, secIndex, true);
		},

		onVideoSeeked(secIndex) {
			const videoArr = this.$refs[`commVideo_${secIndex}`];
			const video = Array.isArray(videoArr) ? videoArr[0] : videoArr;
			if (!video) return;

			// clear seeking state
			this.$set(this.isVideoSeekingMap, secIndex, false);

			// if it was playing, continue playing
			if (video.paused) {
				video.play().catch(() => {});
			}
		},

		onVideoPause(secIndex) {
			// ❌ Ignore pause caused by seeking
			if (this.isVideoSeekingMap[secIndex]) return;

			// ✅ Real pause (user clicked pause)
			this.pauseAllAudios();
		},
		toggleAISummary(index) {
			this.$set(this.showFullAISummary, index, !this.showFullAISummary[index]);
		},

		shouldShowReadMore(text) {
			// heuristic threshold — works reliably for 2 lines @ fs-16
			return text && text.length > 160;
		},
		isCommunicationNotAttempted(section) {
			if (!section.communicationSection) return false;

			if (Number(section.sectionMarks) !== 0) return false;

			if (!Array.isArray(section.sectionResponse)) return true;

			// true only if NO question was attempted
			return section.sectionResponse.every(
				(q) => q.answerStatus && q.answerStatus.attempted === false
			);
		},
		openVideoQuestionFromVideo(secIndex) {
			const section = this.communicationQuestions[secIndex].sectionResponse;

			// find which question this video belongs to
			const quesIndex = section.findIndex(
				(q) => q.answer?.videoPath === this.currentCommVideoPath
			);

			if (quesIndex === -1) return;

			const key = `${secIndex}_${quesIndex}`;

			// MARK this question as currently playing so sync can find it
			this.currentlyPlayingKey = key;

			// OPEN THE QUESTION CARD
			this.$set(this.openCollapseCommunicationQuestion, secIndex, quesIndex);

			//  SCROLL TO THAT CARD
			this.scrollToCommQuestion(secIndex, quesIndex);

			// PLAY AUDIO FOR THIS QUESTION
			this.$nextTick(() => {
				const audioRef = this.$refs[`audioRef2_${secIndex}_${quesIndex}`];
				const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef;

				if (audio) audio.play();
			});
		},
		onCommVideoPlay(secIndex) {
			const videoArr = this.$refs[`commVideo_${secIndex}`];
			const video = Array.isArray(videoArr) ? videoArr[0] : videoArr;
			if (!video) return;

			// 🔹 Mute ONLY on first ever play
			if (!this.hasVideoStartedMap[secIndex]) {
				video.muted = true;
				this.$set(this.hasVideoStartedMap, secIndex, true);
			}

			// 1. open + scroll the right question
			this.openVideoQuestionFromVideo(secIndex);

			// 2. keep your old audio→video sync logic working
			this.syncVideoToCurrentAudio();
		},
		scrollToCommQuestion(secIndex, quesIndex) {
			this.$nextTick(() => {
				// wait for collapse animation to complete
				setTimeout(() => {
					const cardRef = this.$refs[`commQuesCard_${secIndex}_${quesIndex}`];
					const cardEl = Array.isArray(cardRef) ? cardRef[0] : cardRef;

					const scrollRef = this.$refs[`scrollContainer_${secIndex}`];
					const scrollEl = Array.isArray(scrollRef) ? scrollRef[0] : scrollRef;

					if (!cardEl || !scrollEl) return;

					// Scroll so card end is visible
					const cardTop =
						cardEl.getBoundingClientRect().top -
						scrollEl.getBoundingClientRect().top +
						scrollEl.scrollTop;

					const cardBottom = cardTop + cardEl.offsetHeight;

					const target = cardBottom - scrollEl.clientHeight + 20; // 20px padding

					scrollEl.scrollTo({
						top: target < 0 ? 0 : target,
						behavior: "smooth",
					});
				}, 350); // matches collapse duration
			});
		},
		restoreVideoToOriginal(secIndex) {
			const videoEl = this.$refs["videoContainer_" + secIndex]?.[0];
			if (!videoEl) return;

			// If already in full mode, don’t do anything
			if (!this.isMiniMap[secIndex]) return;

			// Get BEFORE bounding box (while mini)
			const rectBefore = videoEl.getBoundingClientRect();

			// Turn off mini mode
			this.$set(this.isMiniMap, secIndex, false);

			this.$nextTick(() => {
				// Clean dragging inline styles
				videoEl.style.left = "";
				videoEl.style.top = "";
				videoEl.style.right = "";
				videoEl.style.bottom = "";
				videoEl.style.position = "";
				videoEl.style.transform = "";
				videoEl.classList.remove("dragging");

				// AFTER bounding box (full size)
				const rectAfter = videoEl.getBoundingClientRect();

				// Calculate delta for reverse animation
				const dx = rectBefore.x - rectAfter.x;
				const dy = rectBefore.y - rectAfter.y;
				const scale = rectBefore.width / rectAfter.width;

				// INVERT: set transform from old → new
				videoEl.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;

				// PLAY ANIMATION
				requestAnimationFrame(() => {
					videoEl.style.transition = "transform .35s cubic-bezier(.4,0,.2,1)";
					videoEl.style.transform = "";
				});

				// Remove transition after end
				setTimeout(() => {
					videoEl.style.transition = "";
				}, 400);
			});
		},
		formattedSentence(question) {
			const text = question.additionalInfo?.sentenceWithPauses || "";

			const icon = `<img src="${pauseIcon}" class="pause-icon" />`;

			return text.replace(/<pause>/g, icon);
		},
		stopDragging(secIndex) {
			this.isDraggingMap[secIndex] = false;

			const videoEl = this.$refs["videoContainer_" + secIndex]?.[0];
			if (!videoEl) return;

			const screenWidth = window.innerWidth;
			const rect = videoEl.getBoundingClientRect();
			const finalX = rect.left + rect.width / 2; // center point

			// smooth transition
			videoEl.style.transition = "all 180ms ease";

			if (finalX < screenWidth / 2) {
				// snap to left bottom
				videoEl.style.left = "10px";
				videoEl.style.right = "auto";
				videoEl.style.bottom = "10px";
				videoEl.style.top = "auto";
			} else {
				// snap to right bottom
				videoEl.style.right = "10px";
				videoEl.style.left = "auto";
				videoEl.style.bottom = "10px";
				videoEl.style.top = "auto";
			}

			// remove transition after animation
			setTimeout(() => {
				videoEl.style.transition = "";
			}, 200);
		},
		makeDraggable(el) {
			if (!el) return;

			let offsetX = 0,
				offsetY = 0;

			el.addEventListener("mousedown", (e) => {
				const allowedContainer = document.getElementById("section-4");

				// Only allow dragging INSIDE #section-4
				if (!allowedContainer || !allowedContainer.contains(e.target)) {
					return;
				}

				el.classList.add("dragging");

				const rect = el.getBoundingClientRect();
				offsetX = e.clientX - rect.left;
				offsetY = e.clientY - rect.top;

				const move = (ev) => {
					el.style.position = "fixed";
					el.style.left = ev.clientX - offsetX + "px";
					el.style.top = ev.clientY - offsetY + "px";
					el.style.right = "auto";
					el.style.bottom = "auto";
				};

				const up = () => {
					el.classList.remove("dragging");

					// ⭐ SNAP LOGIC — LEFT or RIGHT BOTTOM
					const screenWidth = window.innerWidth;
					const finalRect = el.getBoundingClientRect();
					const finalCenterX = finalRect.left + finalRect.width / 2;

					// smooth snap transition
					el.style.transition = "all 180ms ease";

					if (finalCenterX < screenWidth / 2) {
						// snap to left bottom
						el.style.left = "90px";
						el.style.right = "auto";
						el.style.bottom = "10px";
						el.style.top = "auto";
					} else {
						// snap to right bottom
						el.style.right = "10px";
						el.style.left = "auto";
						el.style.bottom = "10px";
						el.style.top = "auto";
					}

					// cleanup transition property
					setTimeout(() => {
						el.style.transition = "";
					}, 200);

					window.removeEventListener("mousemove", move);
					window.removeEventListener("mouseup", up);
				};

				window.addEventListener("mousemove", move);
				window.addEventListener("mouseup", up);
			});
		},

		formatSectionMarks(value) {
			const num = Number(value);
			if (Number.isInteger(num)) {
				return num.toString();
			}
			return num.toFixed(1);
		},
		getQuestionBadgeClass(question) {
			if (question.extraQuestion) return "bg-grey color-darkgrey";

			if (!question.answerStatus || !question.answerStatus.attempted)
				return "bg-grey color-darkgrey";

			const marks = question.questionMarks;
			const total = question.questionBody.marks;
			const step = total / 10;

			if (marks <= step) return "bg-matte-red color-red-progress";
			if (marks <= step * 2) return "bg-matte-orange color-orange-progress";
			if (marks <= step * 3) return "bg-matte-yellow color-yellow-progress";

			return "bg-matte-green color-green-progress";
		},
		toggleCommCollapse(secIndex, attempted, quesIndex) {
			if (!attempted) return;

			const alreadyOpen =
				this.openCollapseCommunicationQuestion[secIndex] === quesIndex;

			// Toggle collapse
			this.$set(
				this.openCollapseCommunicationQuestion,
				secIndex,
				alreadyOpen ? null : quesIndex
			);

			// Scroll only when opening
			if (!alreadyOpen) {
				// Wait for collapse animation to complete
				setTimeout(() => {
					const cardEl = this.$refs[
						`commQuesCard_${secIndex}_${quesIndex}`
					]?.[0];
					const scrollEl = this.$refs[`scrollContainer_${secIndex}`]?.[0];

					if (!cardEl || !scrollEl) return;

					// Deep nested scroll calculation
					const scrollOffset =
						cardEl.getBoundingClientRect().top -
						scrollEl.getBoundingClientRect().top +
						scrollEl.scrollTop;

					scrollEl.scrollTo({
						top: scrollOffset - 10, // smooth alignment
						behavior: "smooth",
					});
				}, 350); // wait for collapse height to open
			}
		},
		hasAllMedia(question) {
			return question?.questionBody?.options?.every(
				(opt) => opt.media && opt.media.trim() !== ""
			);
		},
		isImage,
		isAudio,
		isVideo,
		getCommunicationText(section) {
			const total = section.serctionTotalMarks;
			const marks = Number(section.sectionMarks);

			if (
				section.communicationSection === true &&
				marks === 0 &&
				Array.isArray(section.sectionResponse) &&
				section.sectionResponse.every(
					(q) => q.answerStatus && q.answerStatus.attempted === false
				)
			) {
				return "No results available";
			}

			if (marks <= total / 4) return "Fair Communication Skills!";
			if (marks <= (total / 4) * 2) return "Okay Communication Skills";
			if (marks <= (total / 4) * 3) return "Good Communication Skills";
			return "Great Communication Skills!";
		},
		formatDuration(seconds) {
			seconds = Number(seconds);
			const h = Math.floor(seconds / 3600);
			const m = Math.floor((seconds % 3600) / 60);
			const s = Math.floor(seconds % 60);

			if (h > 0) return `${h}h ${m}m ${s}s`;
			if (m > 0) return `${m}m ${s}s`;
			return `${s}s`;
		},
		initFloatingVideo() {
			this.$nextTick(() => {
				const mainRoot = this.$refs.mainScrollContainer;

				// for each section
				this.communicationQuestions.forEach((section, secIndex) => {
					const videoEl = this.$refs["videoContainer_" + secIndex]?.[0];
					const triggerEl = this.$refs["floatTrigger_" + secIndex]?.[0];
					const scrollEl = this.$refs["scrollContainer_" + secIndex]?.[0];

					if (!videoEl || !triggerEl || !mainRoot) return;

					const observer = new IntersectionObserver(
						(entries) => {
							const isTriggerVisible = entries[0].isIntersecting;
							const shouldFloat = !isTriggerVisible;

							// avoid floating at start
							if (scrollEl && scrollEl.scrollTop < 40) {
								if (this.isMiniMap[secIndex]) {
									this.$set(this.isMiniMap, secIndex, false);
								}
								return;
							}

							if (this.isMiniMap[secIndex] === shouldFloat) return;

							const rectBefore = videoEl.getBoundingClientRect();

							this.$set(this.isMiniMap, secIndex, shouldFloat);

							if (!shouldFloat) {
								this.$nextTick(() => {
									videoEl.style.left = "";
									videoEl.style.top = "";
									videoEl.style.right = "";
									videoEl.style.bottom = "";
									videoEl.style.position = "";
									videoEl.style.transform = "";
									videoEl.classList.remove("dragging");
								});
							}

							this.$nextTick(() => {
								requestAnimationFrame(() => {
									const rectAfter = videoEl.getBoundingClientRect();

									const dx = rectBefore.left - rectAfter.left;
									const dy = rectBefore.top - rectAfter.top;
									const scale = rectBefore.width / rectAfter.width;

									videoEl.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;

									requestAnimationFrame(() => {
										videoEl.style.transition =
											"transform 0.35s cubic-bezier(.4,0,.2,1)";
										videoEl.style.transform = "";
									});

									setTimeout(() => {
										videoEl.style.transition = "";
									}, 400);
								});
							});
						},
						{
							root: mainRoot, // trigger works correctly here
							threshold: 0.01,
						}
					);

					observer.observe(triggerEl);

					this.$nextTick(() => {
						this.makeDraggable(videoEl);
					});
				});
			});
		},

		getCommunicationColor(section) {
			const total = Number(section.serctionTotalMarks || 0);
			const obtained = Number(section.sectionMarks || 0);

			if (!total || total === 0) return "grey"; // fallback

			// Divide into 4 equal parts
			const range = total / 4;

			if (obtained <= range) return "red"; // 0–25%
			if (obtained <= range * 2) return "orange"; // 26–50%
			if (obtained <= range * 3) return "yellow"; // 51–75%
			return "green"; // 76–100%
		},
		getScoreColor(score) {
			if (score <= 0.5) return "color-red-progress";
			if (score <= 1) return "color-yellow-progress";
			if (score <= 1.5) return "color-orange-progress";
			return "color-green-progress";
		},
		getColor(scoreObj) {
			if (!scoreObj || !scoreObj.color) return "primary"; // fallback

			const map = {
				red: "danger",
				orange: "warning",
				yellow: "info",
				green: "success",
			};

			return map[scoreObj.color.toLowerCase()] || "primary";
		},
		formattedTime(secIndex, quesIndex) {
			const key = `${secIndex}_${quesIndex}`;
			const time = this.currentTimeMap[key] || 0;
			const min = Math.floor(time / 60);
			const sec = Math.floor(time % 60);
			return `${min}:${sec.toString().padStart(2, "0")}`;
		},
		seekAudio(event, secIndex, quesIndex) {
			const key = `${secIndex}_${quesIndex}`;
			const audioArr = this.$refs[`audioRef2_${key}`];
			const audio = Array.isArray(audioArr) ? audioArr[0] : audioArr;
			if (!audio) return;

			const rect = event.currentTarget.getBoundingClientRect();
			let percent = (event.clientX - rect.left) / rect.width;

			// clamp 0-1 for safety
			percent = Math.max(0, Math.min(1, percent));

			const duration = this.durationMap[key] || audio.duration || 0;
			audio.currentTime = percent * duration;

			this.$set(this.currentTimeMap, key, audio.currentTime);
		},
		toggleAudio2(secIndex, quesIndex) {
			const key = `${secIndex}_${quesIndex}`;

			const audioArr = this.$refs[`audioRef2_${key}`];
			const audio = Array.isArray(audioArr) ? audioArr[0] : audioArr;
			if (!audio) return;

			let video = this.$refs[`commVideo_${secIndex}`];
			video = Array.isArray(video) ? video[0] : video;
			if (!video) return;

			// Path for THIS question’s video
			this.currentCommVideoPath = this.communicationQuestions[
				secIndex
			].sectionResponse[quesIndex].answer?.videoPath;

			// ⭐ NEW: STORE which question this video belongs to
			this.currentVideoSecIndex = secIndex;
			this.currentVideoQuesIndex = quesIndex;

			this.$nextTick(() => {
				// CASE 1: If audio is currently playing → pause both
				if (!audio.paused && !audio.ended) {
					audio.pause();
					video.pause();
					this.$set(this.isPlayingMap, key, false);
					return;
				}

				// CASE 2: If audio finished → restart from beginning
				if (audio.ended) {
					const key = `${secIndex}_${quesIndex}`;
					audio.currentTime = 0;
					video.currentTime = 0;

					// reset progress immediately
					this.$set(this.currentTimeMap, key, 0);
				}

				// CASE 3: Stop all other audio/video before starting this
				this.pauseAllAudios();

				const syncAndPlay = () => {
					video.currentTime = audio.currentTime || 0;
					video.play();
					audio.play();

					this.currentlyPlayingKey = key;
					this.$set(this.isPlayingMap, key, true);
				};

				if (video.readyState >= 1) syncAndPlay();
				else
					video.addEventListener("loadedmetadata", syncAndPlay, { once: true });
			});
		},
		pauseAllAudios() {
			// Pause *all* audios
			Object.keys(this.$refs).forEach((refKey) => {
				if (refKey.startsWith("audioRef2_")) {
					const arr = this.$refs[refKey];
					const el = Array.isArray(arr) ? arr[0] : arr;
					if (el && typeof el.pause === "function") el.pause();
				}
			});

			// Pause *all* videos per section
			Object.keys(this.$refs).forEach((refKey) => {
				if (refKey.startsWith("commVideo_")) {
					const arr = this.$refs[refKey];
					const el = Array.isArray(arr) ? arr[0] : arr;
					if (el && typeof el.pause === "function") el.pause();
				}
			});
		},

		syncVideoToCurrentAudio() {
			if (!this.currentlyPlayingKey) return;

			const [secIndex] = this.currentlyPlayingKey.split("_");

			let video = this.$refs[`commVideo_${secIndex}`];
			video = Array.isArray(video) ? video[0] : video;
			if (!video) return;

			const audioArr = this.$refs[`audioRef2_${this.currentlyPlayingKey}`];
			const audio = Array.isArray(audioArr) ? audioArr[0] : audioArr;
			if (!audio) return;

			// Safely seek audio to video's currentTime then play.
			// Pause first to avoid race between play() and currentTime set.
			try {
				audio.pause();
				const targetTime = Math.max(
					0,
					Math.min(video.currentTime || 0, audio.duration || Infinity)
				);
				// Some browsers require waiting for metadata/duration; attempt set and fallback to 'seeked' listener.
				let didSeek = false;
				const onSeeked = () => {
					didSeek = true;
					audio.removeEventListener("seeked", onSeeked);
					audio.play().catch(() => {});
				};
				audio.addEventListener("seeked", onSeeked);
				try {
					audio.currentTime = targetTime;
				} catch (e) {
					// If setting currentTime failed because metadata isn't loaded, wait for loadedmetadata then set
					const onLoaded = () => {
						audio.removeEventListener("loadedmetadata", onLoaded);
						try {
							audio.currentTime = targetTime;
						} catch (err) {
							console.log(err);
						}
					};
					audio.addEventListener("loadedmetadata", onLoaded);
				}

				// Fallback: if seeked doesn't fire within 150ms, try to play anyway
				setTimeout(() => {
					if (!didSeek) {
						audio.removeEventListener("seeked", onSeeked);
						audio.play().catch(() => {});
					}
				}, 150);
			} catch (err) {
				// best-effort: attempt simple sync
				audio.currentTime = video.currentTime || 0;
				audio.play().catch(() => {});
			}

			this.$set(this.isPlayingMap, this.currentlyPlayingKey, true);
		},
		onAudioLoaded(secIndex, quesIndex) {
			const key = `${secIndex}_${quesIndex}`;
			const audioArr = this.$refs[`audioRef2_${key}`];
			const audio = Array.isArray(audioArr) ? audioArr[0] : audioArr;
			if (!audio) return;

			// --- Fix: Do NOT touch currentTime here ---
			this.$set(this.currentTimeMap, key, 0);

			// --- Fix: Keep checking until duration becomes valid ---
			const waitForDuration = () => {
				const d = audio.duration;

				if (d && !isNaN(d) && d !== Infinity) {
					this.$set(this.durationMap, key, d);
					return;
				}

				// retry smoothly
				requestAnimationFrame(waitForDuration);
			};

			waitForDuration();

			// clean end handler
			audio.onended = () => {
				audio.currentTime = 0;
				this.$set(this.currentTimeMap, key, 0);
			};
		},
		updateTimeline(secIndex, quesIndex) {
			const key = `${secIndex}_${quesIndex}`;
			const audioArr = this.$refs[`audioRef2_${key}`];
			const audio = Array.isArray(audioArr) ? audioArr[0] : audioArr;
			if (!audio) return;

			const duration = this.durationMap[key];
			if (!duration || isNaN(duration) || duration === Infinity) return;

			let current = audio.currentTime;

			// ⭐ SNAP FIX — increased tolerance for all audio variations
			if (duration - current <= 0.5) {
				current = duration;
			}

			this.$set(this.currentTimeMap, key, current);
		},
		getBackgroundColor(confidence) {
			const colors = {
				fair: "#D7342C",
				good: "#F9C82B",
				okay: "#E99E32",
				amazing: "#2AA869",
			};
			const color = colors[confidence?.toLowerCase()] || "#CCCCCC";
			return `background-color: ${color}`;
		},
		getConfideneceImage(confidence) {
			if (confidence === "fair") {
				return require("../../assets/newimgs/fair-meter.svg");
			} else if (confidence === "good") {
				return require("../../assets/newimgs/good-meter.svg");
			} else if (confidence === "okay") {
				return require("../../assets/newimgs/okay-meter.svg");
			} else if (confidence === "amazing") {
				return require("../../assets/newimgs/amazing-meter.svg");
			} else {
				return require("../../assets/newimgs/no-communication.svg");
			}
		},
		getClass(name) {
			let color = "green";
			if (name === "Head") color = "#AD1927";
			else if (name === "Mouth") color = "#038E00";
			else if (name === "Cheating") color = "#FFC145";
			else if (name === "Eye") color = "#20639B";
			else if (name === "Browser") color = "#72738E";
			else if (name === "Agent") color = "#4B81AE";

			return {
				"background-color": color,
			};
		},
		syncWithVideo(timeStr) {
			if (timeStr) {
				const parts = timeStr.split(":").map(Number);
				if (parts.length === 3) {
					this.seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
				} else if (parts.length === 2) {
					this.seconds = parts[0] * 60 + parts[1];
				} else if (parts.length === 1) {
					this.seconds = parts[0];
				}
			}
			this.getProctorGraph();
			this.seekToTimestamp();
			this.seekForScreenShare();
		},
		seekToTimestamp() {
			const video = document.getElementById("cameraVideo");
			video.currentTime = this.seconds;
			this.tooglePlay = true;
			video.play();
		},
		seekForScreenShare() {
			const video = document.getElementById("screenVideo");
			video.currentTime = this.seconds;
			video.play();
		},
		async getProctoringData(attempt) {
			let payload = {
				topicID: this.$route.params.topicID,
				testID: this.$route.params.testID,
				groupID: this.$route.params.groupID,
				candidateID: this.$route.params.candidateID,
				// topicID: "L041223A001C001",
				// testID: "L041223A001C002T003",
				// groupID: "L041223A001GRP001",
				// candidateID: "bc1e2435-130f-4044-84bc-6815f56d9d2f",
				attemptNo: attempt,
			};

			const response = await getProctoringData(payload);
			if (response.status == 200) {
				this.agentTimeStamps = response.data?.data?.agentTimeStamps;
				this.extensionTimeStamps = response.data?.data?.extensionTimeStamps;
				this.allProctorData = response.data?.data?.videoProctoringTimeStamps;
				if (
					(this.allProctorData.length > 0 &&
						this.allProctorData[0]?.mouthMovementData?.length > 0) ||
					this.allProctorData[0]?.headMovementData?.length > 0 ||
					this.allProctorData[0]?.cheatingProbabilityGazeData?.length > 0 ||
					this.allProctorData[0]?.eyeGazeTrackingData?.length > 0
				) {
					this.graphGeneartion = true;
					setTimeout(() => {
						this.getProctorGraph();
					}, 1000);
				}
				this.marker1 = {
					color: "blue",
					data: this.agentTimeStamps[0]?.allTimeStamps,
				};
				this.marker2 = {
					color: "orange",
					data: this.extensionTimeStamps[0]?.allTimeStamps,
				};
			}
		},
		showLogData(item) {
			this.showLogs = true;
			this.logData = item;
		},
		async getProctorGraph(name = null) {
			const element = document.getElementById("cheatingGraph");
			if (element && this.allProctorData.length > 0) {
				element.innerHTML = "";
				const originalData = this.allProctorData[0];

				const headMovementData = [...originalData.headMovementData];
				const mouthMovementData = [...originalData.mouthMovementData];
				const cheatingProbabilityData = [
					...originalData.cheatingProbabilityGazeData,
				];
				const eyeTrackingData = [...originalData.eyeGazeTrackingData];
				const cheatingWindow = Object.values(
					originalData.cheatingWindowFormatted
				);

				const windowData = Object.fromEntries(
					Object.entries(cheatingWindow).map(([key, value]) => {
						return [
							key,
							{
								window: value.window.start,
								duration: value.duration,
							},
						];
					})
				);

				const dataMap = {
					Head: headMovementData,
					Mouth: mouthMovementData,
					Cheating: cheatingProbabilityData,
					Eye: eyeTrackingData,
				};

				if (name) {
					for (const [key, dataArray] of Object.entries(dataMap)) {
						if (key !== name) {
							dataMap[key].splice(0, dataArray.length);
						}
					}
				}

				const cheatingWindowSizeInSec = this.allProctorData[0]
					?.cheatingWindowSizeInSec;
				const graph = new ProctorGraph();
				const chartControls = await graph.proctoringGraph(
					"#cheatingGraph",
					dataMap.Head,
					dataMap.Mouth,
					dataMap.Cheating,
					dataMap.Eye,
					cheatingWindowSizeInSec,
					this.seconds,
					this.agentTimeStamps[0]?.allTimeStamps,
					this.extensionTimeStamps[0]?.allTimeStamps,
					windowData,
					this.syncWithVideo
				);

				document
					.getElementById("zoom-in")
					.addEventListener("click", chartControls.zoomIn);
				document
					.getElementById("zoom-out")
					.addEventListener("click", chartControls.zoomOut);

				document.getElementById("reset").addEventListener("click", async () => {
					chartControls.reset();
					await this.getProctorGraph();
				});
			}
		},
		async vewSandboxCode() {
			this.$router.push({
				name: "view-code-sandbox",
				params: {
					testID: this.$route.params.testID,
					attemptNo:
						this.$route.query.attemptNo || this.overallResult.data.attemptNo,
					topicID: this.$route.params.topicID,
					groupID: this.$route.params.groupID,
					userID: this.selectedAttempt.candidateID,
					emailID: this.selectedAttempt.emailID,
				},
			});
		},
		selectRunningTc(selectedCase) {
			this.selectedCase = selectedCase;
		},
		async runCodeForCompilation(selectedCondingQuestion) {
			if (this.isCompiling) return;
			this.isCompiling = true;
			try {
				const extractedCode = this.editorInstance.getValue();
				let payloadtestCasesRes = {
					language_id: this.codeData.languageID,
					source_code: extractedCode,
					questionKey: selectedCondingQuestion.questionKey,
				};
				let testCasesRes = await testCaseRunner(payloadtestCasesRes);
				if (testCasesRes.status == 200) {
					this.compiledTestCasesResult = testCasesRes.data.data;
					this.selectedCase = this.compiledTestCasesResult.testCaseResult[0];
					this.testCaseResult = true;
					this.$nextTick(() => {
						const scrollContainer = this.$refs.scrollContainer;
						scrollContainer?.scrollIntoView({
							behavior: "smooth",
							block: "end",
						});
					});
				} else {
					this.errorToast("Compilation Failed");
				}
			} catch (e) {
				console.error(e);
				this.errorToast("Compilation Error");
			} finally {
				this.isCompiling = false;
			}
		},
		initializeEditor() {
			let snip = this.selectedCodingQuestion.answer.body;
			const editorContainer = document.querySelector(".editorContainer");
			window.require.config({
				paths: {
					vs: "https://cdn.jsdelivr.net/npm/monaco-editor@latest/min/vs",
				},
			});
			window.require(["vs/editor/editor.main"], () => {
				this.editorInstance = window.monaco.editor.create(editorContainer, {
					value: snip,
					language: this.topicCardselected,
					theme: "vs-dark",
					readOnly: true,
				});
			});
		},
		selectTc(question) {
			this.selectedTestCase = question;
		},
		showCodingAnswer(question, section) {
			console.log("the section", section);
			this.codeSection = section;
			this.showCodingAnswerModal = true;
			this.testCaseResult = false;
			this.showAnswer = question.questionKey;
			this.selectedCodingQuestion = question;
			this.visibletc = question.questionBody.testCases;
			this.codeData = this.selectedCodingQuestion.answer;

			this.activeForTopic = this.codeData.languagename;
			this.topicCardselected = this.codeData.languagename;
			this.selectedTestCase = this.visibletc[0];
			// this.initializeEditor();
			setTimeout(() => {
				this.initializeEditor();
			}, 1000);
		},
		formatDate(dateString) {
			const date = new Date(dateString);
			const day = String(date.getDate()).padStart(2, "0");
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const year = date.getFullYear();
			return `${day}/${month}/${year}`;
		},
		selectCodingSection(section) {
			this.selectedCodeSection = section;
			// this.codingsection = true;
		},
		selectCommunicationSection(section) {
			this.selectedCommunicationSEction = section;

			this.pauseAllAudios();

			this.currentlyPlayingKey = null;
			this.isPlayingMap = {};
			this.currentTimeMap = {};
			this.durationMap = {};

			// 🔹 Find the first question that actually has a videoPath
			let firstIndexWithVideo = -1;

			if (section?.sectionResponse?.length > 0) {
				firstIndexWithVideo = section.sectionResponse.findIndex(
					(q) => q.answer && q.answer.videoPath
				);
			}

			if (firstIndexWithVideo !== -1) {
				this.currentCommVideoPath =
					section.sectionResponse[firstIndexWithVideo].answer?.videoPath;
				this.selectedCommQuestionIndex = firstIndexWithVideo;
			} else {
				this.currentCommVideoPath = "";
				this.selectedCommQuestionIndex = 0;
			}

			this.$nextTick(() => {
				const video = Array.isArray(this.$refs.commVideo)
					? this.$refs.commVideo[0]
					: this.$refs.commVideo;
				if (video) video.pause();
			});
		},

		getBackground(question) {
			const { attempted, unattempted } = question.answerStatus;
			const autoCorrection = question.questionBody.config.config.autoCorrection;
			const { questionMarks } = question;

			if (attempted && questionMarks == null && !autoCorrection) {
				return { background: "#4ef085" };
			}
			if (questionMarks != null) {
				return { background: "#84a3fe" };
			}
			if (unattempted) {
				return { background: "#E04A58" };
			}
			return { background: "#e0e0e0" };
		},
		async evaluateTest(isSandbox = false, fromMarksModal = false) {
			this.invalidMarks = {};
			this.invalidSections = [];
			if (isSandbox) {
				if (
					this.sandboxMarks == null ||
					this.sandboxMarks > this.selectedAttempt.totalTestMarks ||
					this.sandboxMarks < 0
				) {
					this.invalidSandboxMarks = true;
					return;
				}
			} else {
				this.selectedAttempt.testResponse.forEach((section) => {
					let sectionHasInvalid = false;
					section.sectionResponse.forEach((question) => {
						// Skip validation for communication section
						if (section.communicationSection) return;

						const key = `${section.sectionID}_${question.questionKey}`;
						const rawValue = question.questionMarks;
						const value = Number(rawValue);
						const maxNegative = this.selectedAttempt.negativeMark * -1;

						if (rawValue === "" || rawValue === null || isNaN(value)) {
							this.$set(this.invalidMarks, key, {
								isInvalid: true,
								reason: "Required",
							});
							sectionHasInvalid = true;
						} else if (
							value < maxNegative ||
							value > question.questionBody.marks
						) {
							this.$set(this.invalidMarks, key, {
								isInvalid: true,
								reason: `Entered Marks Should Be Within The Range Of ${maxNegative} To ${question.questionBody.marks}`,
							});
							sectionHasInvalid = true;
						} else {
							if (this.invalidMarks[key]) {
								this.$delete(this.invalidMarks, key);
							}
						}
					});
					if (sectionHasInvalid) {
						if (!this.invalidSections) this.invalidSections = [];
						this.invalidSections.push(section.sectionName);
					}
				});

				if (Object.keys(this.invalidMarks).length > 0) {
					const sectionList = (this.invalidSections || []).join(", ");
					this.errorToast(
						`Please fill valid marks for all questions in ${sectionList}`
					);
					this.invalidSections = [];
					return;
				}
			}

			this.LoaderStatus = true;

			try {
				const isRouteParams = this.$route?.params;
				const attempt = this.selectedAttempt;

				const payload = {
					topicID: isSandbox ? isRouteParams.topicID : attempt.topicID,
					testID: isSandbox ? isRouteParams.testID : attempt.testID,
					candidateID: isSandbox
						? isRouteParams.candidateID
						: attempt.candidateID,
					groupID: isSandbox ? isRouteParams.groupID : attempt.groupID,
					attemptNo: isSandbox
						? this.$route.query.attemptNo
						: attempt.attemptNo,
					evaluation: {},
				};

				if (isSandbox) {
					const section = attempt.testResponse[0];
					const questionKey = section.sectionResponse[0].questionKey;
					payload.evaluation[section.sectionID] = {
						[questionKey]: Number(this.sandboxMarks),
					};
				} else {
					attempt.testResponse.forEach((section) => {
						const questionMarksMap = {};
						section.sectionResponse.forEach((response) => {
							if (section.communicationSection) {
								questionMarksMap[response.questionKey] = Number(
									response.questionMarks
								);
							} else {
								questionMarksMap[response.questionKey] = parseInt(
									response.questionMarks
								);
							}
						});
						payload.evaluation[section.sectionID] = questionMarksMap;
					});
				}

				const res = await evaluateAnswers(payload);

				if (res.status === 200) {
					this.getProctorDetails(attempt.attemptNo);
					this.showCodingAnswerModal = false;

					if (fromMarksModal) {
						this.successToast("Marks updated successfully!");
					} else {
						this.successToast("Test Evaluated Successfully!");
					}
				} else {
					throw new Error();
				}
			} catch (error) {
				console.error(error);
				this.errorToast(
					"Unable to evaluate, Please tag evaluator and try again"
				);
			} finally {
				this.LoaderStatus = false;
			}
		},

		updateMarks(question, event, section) {
			console.log("the section is", section);
			if (!this.invalidSections) {
				this.invalidSections = [];
			}

			const key = `${section.sectionID}_${question.questionKey}`;
			const inputValue = event ? Number(event) : null;
			const maxNegative = this.selectedAttempt.negativeMark * -1;

			if (this.invalidMarks[key]) {
				this.$delete(this.invalidMarks, key);
			}

			if (event === "" || event === null || isNaN(inputValue)) {
				this.$set(this.invalidMarks, key, {
					isInvalid: true,
					reason: "Required",
				});
			} else if (
				inputValue < maxNegative ||
				inputValue > question.questionBody.marks
			) {
				this.$set(this.invalidMarks, key, {
					isInvalid: true,
					reason: `Entered Marks Should Be Within The Range Of ${maxNegative} To ${question.questionBody.marks}`,
				});
			}

			question.questionMarks = inputValue;

			const sectionHasInvalid = section.sectionResponse.some((q) => {
				const k = `${section.sectionID}_${q.questionKey}`;
				return this.invalidMarks[k]?.isInvalid;
			});

			if (sectionHasInvalid) {
				if (!this.invalidSections.includes(section.sectionName)) {
					this.invalidSections.push(section.sectionName);
				}
			} else {
				this.invalidSections = this.invalidSections.filter(
					(name) => name !== section.sectionName
				);
			}
		},
		toggleAnswer(key) {
			this.showAnswer = this.showAnswer === key ? "" : key;
		},
		getTitle(question) {
			if (!question.questionKey) {
				return "";
			}
			const title = question.questionKey;
			const titleWords = title.slice(0, 3);
			if (titleWords == "MCQ") {
				return `MCQ's`;
			} else if (titleWords == "LON") {
				return "Descriptive";
			} else if (titleWords == "MAF") {
				return "Match The Following";
			} else {
				return "";
			}
		},
		getEvaluationText(attempt) {
			if (!attempt.isSubmitted && attempt.testResponse.length === 0) {
				return "Discontinued Test";
			} else if (attempt.evaluation) {
				return "Evaluated";
			} else if (!attempt.isSubmitted) {
				return "Not Submitted";
			} else {
				return "Not Yet Evaluated";
			}
		},
		initializeAudio(blob) {
			this.audio = new Audio(blob);
			this.audioDuration =
				this.selectedAttempt?.communicationTest?.communicationTestResponse
					?.durationInSeconds || 0;

			this.audio.ontimeupdate = () => {
				const progress = this.audio.currentTime / this.audioDuration;
				this.currentBar = Math.floor(progress * this.waveformData.length);
			};

			this.audio.onended = () => {
				this.isPlaying = false;
				this.currentBar = 0;
			};
		},

		toggleAudio() {
			if (!this.audio) {
				const audioBlob = this.selectedAttempt?.communicationTest
					?.communicationTestResponse?.analysisResult?.audio;
				if (audioBlob) this.initializeAudio(audioBlob);
			}

			if (this.audio) {
				this.isPlaying ? this.audio.pause() : this.audio.play();
				this.isPlaying = !this.isPlaying;
			}
		},

		seekTimeline(event) {
			if (!this.audio) return;

			const waveformEl = event.currentTarget;
			const rect = waveformEl.getBoundingClientRect();
			const clickX = event.clientX - rect.left;
			const percentage = clickX / rect.width;

			const seekTime = percentage * this.audioDuration;
			this.audio.currentTime = seekTime;
		},
		formatDateTime(attempt) {
			if (
				!this.selectedAttempt?.stats?.timing?.startTime &&
				!attempt.createdAt
			) {
				return "--";
			}
			const date = attempt?.stats?.timing?.startTime || attempt.createdAt;
			const parsedDate = new Date(
				date.includes(" ") ? date.replace(" ", "T") : date
			);

			const day = parsedDate.getDate();
			const month = parsedDate.toLocaleString("default", { month: "long" });
			const year = parsedDate.getFullYear();

			const hours = parsedDate.getHours();
			const minutes = parsedDate
				.getMinutes()
				.toString()
				.padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";
			const twelveHour = hours % 12 || 12;

			return `${day} ${month} ${year}, ${twelveHour
				.toString()
				.padStart(2, "0")}:${minutes} ${ampm}`;
		},

		checkForGeolocation() {
			const geo = this.selectedAttempt?.stats?.geolocation?.address
				?.formatted_address;
			return !!geo;
		},
		async getProctorDetailsData(data, event) {
			if (event.detail == 0) {
				return;
			}
			console.log("the data is", data);
			if (this.overallResult.attempts.length > 1) {
				await this.getProctorDetails(data);
				await this.getProctoringData(data);
			}
		},
		getFormattedTopicName(topicName) {
			if (topicName === "Sandbox-KSGPdd3q0S#jl@B") return "Sandbox";
			else return topicName;
		},
		async getProctorDetails(attempt) {
			this.showShimmer = true;
			let payload = {
				topicID: this.$route.params.topicID,
				testID: this.$route.params.testID,
				groupID: this.$route.params.groupID,
				candidateID: this.$route.params.candidateID,
				// topicID: "L041223A001C001",
				// testID: "L041223A001C002T003",
				// groupID: "L041223A001GRP001",
				// candidateID: "bc1e2435-130f-4044-84bc-6815f56d9d2f",
				attemptNo: attempt,
			};
			const res = await getproctoringCandidatesv3(payload);
			if (res.status == 200) {
				this.overallResult = res.data.data;
				this.proctoringData =
					this.overallResult.videoProctoringData
						.videoProctoringTotalActivityCount > 0
						? this.overallResult?.videoProctoringData?.videoProctoring
						: null;
				await this.selectAttempt(res.data.data.data);
				setTimeout(() => {
					this.showShimmer = false;
				}, 1000);
			}
		},
		selectAttempt(data) {
			this.selectedAttempt = data;
			if (this.selectedAttempt.testResponse) {
				this.selectedSection = this.selectedAttempt.testResponse[0];
				this.allQuestions = this.selectedAttempt.testResponse.filter(
					(obj) => !obj.codingSection && !obj.communicationSection
				);
				this.codingquestions = this.selectedAttempt.testResponse.filter(
					(obj) => obj.codingSection
				);
				this.communicationQuestions = this.selectedAttempt.testResponse.filter(
					(obj) => obj.communicationSection
				);
				this.videoDuration = this.durationToSeconds(
					this.selectedAttempt.stats?.timing?.duration
				);
				// if (this.codingquestions.length > 0) {
				// 	const firstQuestion = this.codingquestions[0];
				// 	this.codingquestions = [firstQuestion, firstQuestion, firstQuestion];
				// 	this.selectedCodeSection = this.codingquestions[0];
				// }
				if (this.codingquestions.length > 0) {
					this.selectedCodeSection = this.codingquestions[0];
				}
				if (this.communicationQuestions.length > 0) {
					this.selectedCommunicationSEction = this.communicationQuestions[0];
					this.selectCommunicationSection(this.selectedCommunicationSEction);
				}

				if (
					this.selectedAttempt.sandboxResults &&
					this.selectedAttempt.evaluation
				) {
					this.sandboxMarks = this.selectedAttempt.marks;
				}
			}
		},
		durationToSeconds(durationStr) {
			if (!durationStr) return 0;
			const [hms, micro] = durationStr.split(".");
			const [hours, minutes, seconds] = hms.split(":").map(Number);
			const microseconds = parseInt(micro || "0", 10);

			return hours * 3600 + minutes * 60 + seconds + microseconds / 1000000;
		},
		observeSections() {
			const sectionIds =
				this.selectedAttempt?.sandboxResults &&
				Object.keys(this.selectedAttempt.sandboxResults).length
					? ["section-1", "section-2", "section-3", "section-5"]
					: ["section-1", "section-2", "section-3", "section-4"];
			const options = {
				root: this.$refs.mainScrollContainer,
				rootMargin: "0px",
				threshold: 0.5, // 50% visible
			};
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const id = entry.target.id;
						const index = sectionIds.indexOf(id);
						if (index !== -1) {
							this.activeSection = index + 1;
							if (
								this.activeSection == 5 &&
								this.selectedAttempt.sandboxResults
							) {
								this.activeSection = 4;
							}
						}
					}
				});
			}, options);

			sectionIds.forEach((id) => {
				const el = document.getElementById(id);
				if (el) {
					this.observer.observe(el);
				}
			});
		},

		handleScroll() {
			const sectionIds = [
				"section-1",
				"section-2",
				"section-3",
				"section-4",
				"section-5",
			];
			let closestSectionIndex = 0;
			let smallestDistance = Infinity;

			sectionIds.forEach((id, index) => {
				const el = document.getElementById(id);
				if (el) {
					const rect = el.getBoundingClientRect();
					const sectionMid = rect.top + rect.height / 2;

					// Compare section's midpoint to window center (or some offset)
					const distance = Math.abs(sectionMid - window.innerHeight / 2);

					if (distance < smallestDistance) {
						smallestDistance = distance;
						closestSectionIndex = index;
					}
				} else {
					console.warn(`Element with id '${id}' not found`);
				}
			});

			this.activeSection = closestSectionIndex + 1;
		},

		scrollToSection(index) {
			const target = document.getElementById(`section-${index}`);
			if (target) {
				target.scrollIntoView({ behavior: "smooth", block: "start" });
			}
		},
	},
};
</script>

<style>
.es-main-container {
	top: 70px;
	padding-left: 60px;
	height: calc(100vh - 70px);
	background: #e8ebee;
}
.es-first-section {
	background: #fafafa;
	padding: 20px 25px;
	height: 83px;
}
.es-priority-container {
	padding: 5px 10px;
	width: fit-content;
	background: #fff1c3;
	box-shadow: 0px 0px 0px rgba(86, 86, 86, 0.13);
	border-radius: 4px;
}
.es-attempt-tab-container .card-header {
	padding: 10px 24px;
	background: rgba(114, 115, 142, 0.14);
	border-radius: 0px 0px 8px 8px;
}
.es-attempt-tab-container .nav-item {
	background: #f2f2f2;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 5px;
}
.es-attempt-tab-container .nav {
	gap: 20px;
}
.es-attempt-tab-container .nav-item a {
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	color: #2e425d;
	padding: 5px 15px;
}
.es-attempt-tab-container .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
	color: #ffffff;
	background-color: #72738e;
	border: 1px solid rgba(140, 140, 140, 0.3);
}
.es-firstsec-left-container {
	background: linear-gradient(
		180.05deg,
		#72738e 0.04%,
		rgba(32, 32, 40, 0.91) 99.96%
	);
	border-radius: 8px 0px 0px 8px;
}
.es-firstsec-right-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 0 8px 8px 0;
}
.es-attempt-tab-container .tabs {
	background: #e8ebee;
}
.es-attempt-tab-container .tab-content {
	position: relative;
}
.es-attempt-tab-container .card-body {
	height: 100%;
	padding: 24px;
}

.es-profile-dp {
	width: 100px;
	height: 100px;
	border: 0.695715px solid #72738e;
	border-radius: 50px;
	/* background: white; */
}
.es-profile-btn {
	padding: 5px 16px;
	background: #72738e;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 100px;
	width: fit-content;
}
.white-dotted-hr {
	/* border: 1px dashed rgba(255, 255, 255, 0.23); */
	border: 1px solid transparent;
	border-image: repeating-linear-gradient(
		to right,
		rgba(255, 255, 255, 0.23) 0,
		rgba(255, 255, 255, 0.23) 6px,
		transparent 6px,
		transparent 12px
	);
	border-image-slice: 1;
}
.grey-dotted-hr {
	/* border: 1px dashed rgba(114, 115, 142, 0.23); */
	border: 1px solid transparent;
	border-image: repeating-linear-gradient(
		to right,
		rgba(114, 115, 142, 0.23) 0,
		rgba(114, 115, 142, 0.23) 6px,
		transparent 6px,
		transparent 12px
	);
	border-image-slice: 1;
}
.es-vertical-line {
	position: absolute;
	left: 45%;
	top: -20px;
	width: 2px;
	height: 275px;
	background-image: repeating-linear-gradient(
		to bottom,
		rgba(114, 115, 142, 0.23) 0,
		rgba(114, 115, 142, 0.23) 6px,
		transparent 6px,
		transparent 12px
	);
	background-repeat: repeat-y;
	background-size: 2px 12px;
	border: none;
}
.es-cheating-tag {
	padding: 3px 12px;
	background: rgba(173, 25, 39, 0.1);
	border-radius: 4px;
}
.es-viewmark-btn {
	padding: 5px 16px;
	background: #72738e;
	border-radius: 40px;
	width: 232px;
}
.es-vertical-line {
	transform: rotate(180.05deg);
	position: absolute;
	left: 45%;
	height: 275px;
	top: -30px;
}
.es-idcapture {
	width: 426px;
	height: 228px;
	background: linear-gradient(180deg, #474747 0%, #a7a5a5 100%);
	border-radius: 13.0383px;
	overflow: hidden;
}
.es-secondsec-left-container {
	background: #ffffff;
	border-radius: 16px;
	position: relative;
	padding: 16px;
}
.es-secondsec-right-top-empty {
	height: 294px;
	background: #ffffff;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.es-secondsec-right-bottom {
	height: calc(100vh - 410px);
	background: #ffffff;
	border-radius: 8px;
	padding: 16px;
}
.es-greyheader {
	padding: 8px 16px;
	background: rgba(114, 115, 142, 0.1);
	border-radius: 6px;
}
.es-facecam {
	height: 41%;
	border-radius: 6px;
	overflow: hidden;
}
.es-ss-boxes {
	padding: 12px;
	width: 160px;
	height: 72px;
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 4px;
}
.selected-es-ss-box {
	background: rgba(114, 115, 142, 0.15);
	border: 1px solid #72738e;
}
.es-cheatpercentage-container {
	padding: 8px 12px;
	background: #ffffff;
	border: 1px solid rgba(114, 115, 142, 0.3);
	border-radius: 6px;
}
.es-cp-tag {
	width: 53px;
	height: 28px;
	background: #ededf0;
	border-radius: 100px;
}
.es-third-top-container {
	background: #ffffff;
	border-radius: 8px;
	height: 175px;
	padding: 16px;
}
.es-third-bottom1-container {
	background: #72738e;
	border-radius: 8px 8px 0px 0px;
}
.es-third-bottom1-boxes {
	height: 90px;
	background: #f6f6fc;
	border-radius: 8px;
	padding: 15px;
}
.amazing-tag {
	padding: 4px 12px;
	border-radius: 4px;
	width: fit-content;
}
.w-33 {
	width: 33%;
}
.w-34 {
	width: 34%;
}
.es-third-bottom2-container {
	background: #ffffff;
	border-radius: 0 0 8px 8px;
	height: calc(100vh - 460px);
	overflow: auto;
}
.es-third-keywords-container {
	padding: 6px 12px;
	background: #f6f6fc;
	border-radius: 3px;
}
.h-135px {
	height: 135px;
}
.h-160px {
	height: 160px;
}
.es-ct-answer-container {
	/* height: 100px; */
	background: #fafafa;
	border: 1px solid rgba(200, 200, 200, 0.5);
	border-radius: 4px;
	overflow: auto;
	padding: 10px;
}
.es-tt-question-container {
	width: 621px;
	height: 48%;
	overflow: auto;
	background: #f6f6fc;
	border-radius: 4px;
}
.negativemark-container {
	padding: 11px 10px;
	background: #f4f4f4;
	border-radius: 3px;
}
.evaluated-boxes {
	background: #ffffff;
	border: 0.7px solid #e5e5e5;
	border-radius: 5px;
	padding: 11px 10px;
}
.es-last-section-tabs .nav {
	gap: 0;
}
.es-last-section-tabs .nav-item a {
	border-radius: 5px 5px 0px 0px;
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	color: #72738e;
	height: 37px;
	width: 260px;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #dddddd;
	background: #ffffff;
}
.es-last-section-tabs .nav-item a {
	padding: 0;
}
.es-last-section-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	background: #72738e;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 5px 5px 0px 0px;
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	height: 38px;
	width: 260px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.es-last-section-tabs .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
	border-color: #dddddd;
}

.es-section-container-tabs .nav-item {
	background: #f2f2f2;
	border: 1px solid rgba(140, 140, 140, 0.3) !important;
	border-radius: 5px;
	overflow: hidden;
	flex-shrink: 0;
}
.es-section-container-tabs .nav {
	gap: 20px;
	flex-wrap: nowrap;
}
.es-section-container-tabs .nav-item a {
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	font-size: 16px;
	text-align: center;
	color: #2e425d;
	padding: 5px 15px;
	width: 130px;
	background: #f2f2f2;
	/* border: 1px solid rgba(140, 140, 140, 0.3); */
	border-radius: 5px;
}
.es-section-container-tabs .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
	color: #ffffff;
	background-color: #72738e;
	border: 1px solid rgba(140, 140, 140, 0.3);
}
.es-section-container-tabs .card-header {
	padding: 20px 20px 0 20px;
	border-radius: 0;
	background: white;
	border-bottom: unset;
	overflow: auto;
}
.es-section-container-tabs .tab-content {
	height: calc(100vh - 310px);
	background: white;
	overflow: auto;
}
.es-section-container-tabs .card-header::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.es-fbck-answer-container {
	height: 53px;
	background: #f6f6fc;
	border-radius: 3px;
	padding: 9px;
}
.dot-indicator {
	position: fixed;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	gap: 8px;
	z-index: 1;
}
.dot {
	height: 10px;
	width: 10px;
	background-color: #d1d5db;
	border-radius: 50%;
	transition: background-color 0.3s ease;
}
.dot.active {
	background-color: #4f46e5;
}
.audio-wrapper {
	display: flex;
	align-items: center;
}

.play-button {
	width: 40px;
	height: 40px;
	margin-right: 8px;
	cursor: pointer;
}

.waveform {
	display: flex;
	align-items: center; /* Align to vertical center */
	height: 60px; /* Total waveform height */
	position: relative;
}

.wave-bar {
	width: 1px;
	margin: 0 1px;
	background-color: #ccc;
	position: relative;
}

.wave-bar::before,
.wave-bar::after {
	content: "";
	display: block;
	width: 100%;
	background-color: inherit;
	position: absolute;
	left: 0;
}

.wave-bar::before {
	bottom: 50%;
	height: var(--bar-height);
}

.wave-bar::after {
	top: 50%;
	height: var(--bar-height);
}

.es-answercard {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	padding: 15px;
}

.topDiv > .vcp-inputField {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 2px !important;
	font-size: var(--size-14);
	font-weight: 400;
	z-index: 5;
	width: 100px;
	margin-right: 14px;
	color: #6d6d6d;
}
.gridgreencolorDynamic {
	width: 4px;
	height: 97%;
	border-radius: 2px;
	position: absolute;
	left: 3px;
	top: 4px;
}
p {
	margin: 0;
}
.es-showanswer {
	padding: 6px 16px;
	background: #f2f2f2;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 100px;
	width: 165px;
}
.es-answer-box-container {
	padding: 12px 24px;
	background: linear-gradient(
			0deg,
			rgba(170, 230, 169, 0.19),
			rgba(170, 230, 169, 0.19)
		),
		#ffffff;
	border-radius: 0px 0px 5px 5px;
}
.es-answer-optiontag {
	padding: 0px 16px;
	width: 85px;
	background: #269c32;
	border-radius: 100px;
}
.es-footer-section {
	height: 68px;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 0px 0px 5px 5px;
	padding: 0 12px;
}
.rating-input {
	color: #ffc145 !important;
	background: unset;
	border: none;
	background-color: unset !important;
}
.es-notevlted {
	background: #f4f4f4;
	border-radius: 5px;
	width: 240px;
	height: 36px;
}
#viewmarksmodal .modal-body,
#showcodingquestionanswer .modal-body {
	padding: 0;
}
.viewmarks-namebox {
	padding: 16px;
	height: 51px;
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
}
.viewmarks-body-part {
	padding: 16px;
	background: #f5f5f5;
	border-radius: 5px;
}
.viewmarks-markbox {
	padding: 16px;
	height: 49px;
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 4px;
}
.es-eval-validationicon {
	position: absolute;
	top: 4px;
	left: 75px;
	z-index: 23;
}
.es-mtf-crctoption {
	background: #effaef;
	border: 1px solid #269c32;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	padding: 5px 15px;
	word-break: break-all;
}
.es-mtf-wrongoption {
	background: rgba(235, 0, 2, 0.05);
	border: 1px solid #ad1927;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	padding: 5px 15px;
	word-break: break-all;
}
.es-mtf-optionmain {
	background: #f2f2f2;
	border-radius: 3px;
	padding: 1px;
	display: flex;
	align-items: stretch;
}
.es-mtf-answer-option {
	padding: 5px 18px;
	background: #ffffff;
	border-radius: 3px 0px 0px 3px;
}
.w-48 {
	width: 48%;
}
.w-4 {
	width: 4%;
}
.vertical-answer-line {
	width: 1px;
	height: 80%;
	opacity: 0.5;
	background: #3f698e;
	position: absolute;
	left: 5%;
	top: 18px;
}
.es-codingsection .nav-item a {
	width: unset;
}
.no-spinner::-webkit-inner-spin-button,
.no-spinner::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.es-coding-left-container {
	padding: 16px;
	background: rgba(114, 115, 142, 0.1);
	border-radius: 5px;
}
.es-coding-smalltabs {
	padding: 3px 15px;
	background: #ffffff;
	border-radius: 3px;
	width: fit-content;
}
.sampleinputoutput ul li {
	list-style-type: none;
}
.sampleinputoutput ul {
	margin-block-start: 0;
	padding-inline-start: 0px;
}
.es-coding-contraints ul {
	margin-block-start: 0;
	padding-inline-start: 20px;
}
.es-coding-editor {
	height: 342px;
	background: #333333;
	border-radius: 5px;
	overflow: hidden;
}
.es-coding-testcase-container {
	background: #ffffff;
	border-radius: 5px;
	padding: 10px;
}
.es-coding-dd {
	width: 30%;
	height: 209px;
	background: #fbfafa;
	border-radius: 5px;
	overflow: auto;
}
.es-coding-dd .item {
	height: 35px;
	padding-left: 10px;
}
.es-coding-dd .item.selected {
	height: 35px;
	padding-left: 10px;
	background: #eef2f5;
	border-radius: 5px;
}
.p10px {
	padding: 10px;
}
.es-coding-testresult-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 10px 12px;
}
.es-coding-green-header {
	height: 31px;
	background: #269c32;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	padding: 8px;
}
.es-coding-red-header {
	height: 31px;
	background: #ad1927;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	padding: 8px;
}
.es-coding-right-testcase-dd {
	height: 181px;
	background: #fbfafa;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 5px;
	overflow: auto;
	width: 35%;
}
.es-coding-right-testcase-dd .item {
	height: 35px;
	padding-left: 10px;
}
.es-coding-right-testcase-dd .item.selected {
	height: 35px;
	padding-left: 10px;
	background: #eef2f5;
	border-radius: 5px;
}
.w-65 {
	width: 65%;
}
.givemark-btn-disable {
	background: #72738e;
	opacity: 0.4;
}
.evaluate-sandbox-input {
	height: 32px;
	width: 175px;
	padding-right: 45px;
	border-radius: 8px;
}

.out-off-marks-eval {
	position: absolute;
	left: 127px;
	top: 5px;
}

.eval-btns .btn-secondary {
	background-color: #72738e;
	border-radius: 40px;
	border: 1px solid #72738e;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 22px;
	font-family: "Montserrat";
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.eval-btns .btn-secondary:focus {
	box-shadow: 0px 4px 4px 0px #00000040;
}
.es-section-5 {
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}
.es-section-5-cards {
	padding: 11px 8px;
	width: 100%;
	height: 180px;
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}
.es-section-5-cards-container {
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	padding: 10px 30px;
	display: grid;
	grid-template-rows: repeat(auto-fill, minmax(180px, 1fr));
	grid-gap: 15px;
}
.padding1324 {
	padding: 13px 24px;
}
.padding2024 {
	padding: 5px 24px 20px 24px;
}
.sanboxtriggerbox {
	height: 134px;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}
.b-avatar-text span {
	font-size: 3rem;
}
.es-third-container-nofdbck {
	height: 130px;
	padding: 5px 15px;
}
.es-third-bottom2-container-nofdbck {
	height: calc(100vh - 395px);
}

.mob-radio-group .custom-radio.b-custom-control-sm,
.mob-radio-group .input-group-sm .custom-radio,
.mob-radio-group .custom-radio.b-custom-control-md,
.mob-radio-group .input-group-md .custom-radio {
	font-size: 0.875rem;
	line-height: 1.5;
	padding-left: 31px;
	padding-top: 11px;
}

.mob-radio-group .custom-control-label {
	font-family: "Lato", sans-serif;
	font-size: var(--size-11);
	font-weight: var(--weight-LM);
	color: #3a3c40;
	line-height: 21px;
	width: 100%;
	word-break: break-all;
}

.mob-radio-group .custom-control-label::before {
	border: 1px solid #72738e;
}

.mob-radio-group .custom-radio.b-custom-control-sm .custom-control-label::after,
.mob-radio-group .input-group-sm .custom-radio .custom-control-label::after {
	border: 1px solid #72738e;
	border-radius: 50%;
}

.mob-radio-group .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #72738e;
}

.mob-radio-group
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 2px solid #72738e;
	border-radius: 50%;
}

.mob-radio-group
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
}
.mob-radio-group
	.custom-radio
	.custom-control-input:disabled:checked
	~ .custom-control-label::before {
	background-color: #ffffff !important;
}
/* .mob-radio-group .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	color: #72738e;
	padding-top: 0.5px;
}
.es-checkbox .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	color: #72738e;
	padding-top: 2px;
} */
.es-last-section-tabs .nav-item {
	border: unset;
}
.es-instance-box {
	padding: 6px 12px;
	background: #ededf0;
	border-radius: 4px;
	width: 159px;
}
.es-instance-tableheader {
	height: 45px;
	background: #72738e;
	border-radius: 4px;
	padding: 12px 15px;
	justify-content: space-between;
}
.w-35 {
	width: 35%;
}
.es-instance-tablebody {
	height: 45px;
	background: #ffffff;
	border-bottom: ipx dashed #dddddd;
	padding: 12px 15px;
	justify-content: space-between;
}

#cheatingGraph {
	overflow: auto;
}
.graph-wrapper {
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
}

.graph-legend {
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
	align-items: center;
	margin-bottom: 6px;
	justify-content: flex-end;
	padding-top: 10px;
	padding-right: 3%;
}
.graph-legend-button {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	border: 2px solid #72738e;
	border-radius: 20px;
	width: 106px;
	height: 27px;
}

.legend-item {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 500;
	width: 106px;
	height: 27px;
	color: #333;
	border: 2px solid #72738e;
	border-radius: 20px;
}

.legend-color {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	margin-right: 6px;
}
.es-secondsec-right-top {
	height: 294px;
	border-radius: 0; /* inner content, no need to round again */
}
.no-activity-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}
.w-33 {
	width: 33% !important;
}
.lang-selected {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 15px;
}
.communication-img-container {
	background: #f6f6fc;
	border: 1px solid rgba(140, 140, 140, 0.05);
	border-radius: 5px;
}

.image-card {
	height: 300px;
	border: 1px solid #72738e;
}
.video-card {
	margin-top: 20px;
	height: 300px;
	width: 70%;
	border: 1px solid #72738e;
}

.audio-card {
	margin-top: 20px;
	height: 50px;
	width: 70%;
}
.es-communication-card {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	padding: 20px;
}
.es-ct-mainscreen {
	background: #ffffff;
	/* border-top: 1px solid rgba(114, 115, 142, 0.23); */
	border-radius: 0px 8px 8px 8px;
	padding: 15px;
	height: calc(100vh - 235px);
	overflow: auto;
}
.es-ct-vrbox {
	width: 100%;
	height: 304.75px;
	border-radius: 4px;
	/* background: #3f698e; */
}
.es-ct-greenbox {
	border-radius: 8px;
	padding: 5px 8px;
}
.esctgb-rating {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 105px;
	height: 58px;
	border-radius: 6px;
}
.color-2AA869 {
	color: #2aa869;
}
.color-2E425D {
	color: #2e425d;
}
.es-progress .progress {
	height: 8px;
}
.es-prog-tags {
	padding: 8px 16px;

	background: #ffffff;
	border: 1px solid #e5e5e5;
	border-radius: 9999px;
}
.es-collapsed-cards {
	padding: 16px;
	background: #ffffff;
	border: 1px solid #e5e5e5;
	border-radius: 5px;
}
.es-green-tag-collapse {
	padding: 5px 16px;
	height: fit-content;
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	width: 95px;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
}
.es-ct-quescard {
	background: #fbfbfb;
	border: 1.5px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 8px;
}
.es-ct-transcriptcard {
	padding: 16px;
	background: #f4f4f4;
	border-radius: 8px;
}
.color-green-progress {
	color: #038e00;
}
.color-orange-progress {
	color: #fb923c;
}
.color-yellow-progress {
	color: #eab308;
}
.color-red-progress {
	color: #ad1927;
}
.w-20 {
	width: 20%;
}

.bg-warning {
	background-color: #fb923c !important;
}
.bg-danger {
	background-color: #ad1927 !important;
}
.bg-success {
	background-color: #038e00 !important ;
}
.bg-info {
	background-color: #eab308 !important;
}
.bg-primary {
	background-color: #20639b !important;
}
/* .video-wrapper {
	transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.video-wrapper:not(.mini) {
	width: 420px;
}

.video-wrapper.mini {
	position: fixed;
	bottom: 20px;
	right: 20px;
	width: 260px;
	z-index: 9999;
} */
.video-wrapper {
	transform-origin: top left; /* This is what gives the correct direction */
	will-change: transform;
}

/* Remove width transition — do NOT animate width */
.video-wrapper.mini {
	position: fixed;
	bottom: 20px;
	right: 20px;
	z-index: 9999;
	cursor: grab;
	box-shadow: 0px 38.1837px 115.708px rgba(0, 0, 0, 0.4);
	border-radius: 13.885px;
}

/* NON-mini normal size */
.video-wrapper:not(.mini) {
	/* width: 420px; */
	height: auto;
}
.video-inner {
	width: 323px;
	height: 180px;
	background: black;
	border-radius: 13.885px;
}

/* Smooth only while transform animation runs */
.video-wrapper.animating {
	transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.audio-progress {
	width: 100%;
	height: 6px; /* thinner GREY track */
	background: #e5e7eb;
	border-radius: 999px;
	position: relative;
	cursor: pointer;
}

.audio-progress-fill {
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	height: 12px; /* thicker BLUE bar */
	background: #20639b;
	border-radius: 999px;
	transition: width 0.15s linear;
}

.disabled-btn {
	opacity: 0.6;
	cursor: not-allowed;
	pointer-events: auto !important;
}
.rotate-arrow {
	transition: transform 0.3s ease;
	display: inline-block;
}

.rotate-arrow.rotated {
	transform: rotate(180deg);
}
.bg-matte-green {
	background-color: #eef7ef !important;
}
.bg-matte-red {
	background-color: #fcddc8;
}
.bg-matte-orange {
	background-color: #fee9d8;
}
.bg-matte-yellow {
	background-color: #fff0c6;
}
.bg-matte-7a7a7a {
	background: #f1f1f4;
}
.bg-green {
	background-color: #269c32;
}
.bg-yellow {
	background-color: #eab308;
}
.bg-orange {
	background-color: #fb923c;
}
.bg-red {
	background-color: #ad1927;
}
.border-green {
	border: 1px solid #269c32;
}
.border-yellow {
	border: 1px solid #eab308;
}
.border-orange {
	border: 1px solid #fb923c;
}
.border-red {
	border: 1px solid #ad1927;
}
.border-7a7a7a {
	border: 1px solid #7a7a7a;
}
.es-replay-div.disabled {
	opacity: 0.4;
	pointer-events: none;
	cursor: default;
}
.bg-grey {
	background-color: #ededf0;
}
.bg-7a7a7a {
	background: #7a7a7a;
}

.color-darkgrey {
	color: #656565;
}
.es-ta-line {
	width: 16px;
	height: 0px;

	background: #72738e;
	opacity: 0.25;
	border: 1px solid #72738e;
	transform: rotate(90deg);
}
.video-wrapper.mini.dragging {
	cursor: grabbing;
	user-select: none;
}

.br13px {
	border-radius: 13px;
}
.color-grey-progress {
	color: #7a7a7a;
}
.float-trigger {
	height: 1px;
	width: 100%;
}
.es-section-empty-container-tabs .tab-content {
	height: calc(100vh - 234px);
}
.es-aisummary-container {
	background: rgba(49, 116, 172, 0.1);
	border-radius: 8px;
	padding: 16px;
}
.ai-summary-container {
	position: relative;
}

.ai-summary-text {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	line-height: 1.4;
	width: 90%;
}

.ai-summary-text.expanded {
	-webkit-line-clamp: unset;
	overflow: visible;
}

/* fade only the end of last line */
.ai-summary-container::after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 0;
	width: 110px;
	height: 1.4em;
	pointer-events: none;
}

/* hide fade when expanded */
.ai-summary-text.expanded + .ai-read-more ~ ::after {
	display: none;
}

.ai-read-more {
	position: absolute;
	bottom: 0;
	right: 0;
	padding-left: 6px;
}
.fw-900 {
	font-weight: 900;
}
.smalltabs .card-body {
	padding: 15px 12px !important;
}
</style>
